// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Entity/EntityEditPage.css */
/* Same design pattern as PersonEditPage - single page edition */

/* ===================== FULL PAGE LAYOUT ===================== */
/* Covers only the lanes area - sidebar, tabs and scenario header remain visible */

.entity-edit-page {
  position: fixed;
  top: 120px;  /* Below: tabs (~50px) + scenario header (~70px) */
  left: 228px;  /* After sidebar (220px) + lanes padding (8px) */
  right: 8px;   /* Same margin as lanes-container */
  bottom: 8px;  /* Same margin as lanes-container */
  display: flex;
  flex-direction: column;
  background: #F8FAFC;
  z-index: 1100;  /* Above the App save button (z-index: 1000) */
  overflow: hidden;
  border-radius: 10px;  /* Match lanes border-radius */
  border: 1px solid #BDC3C7;  /* Match lanes border */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

@media (max-width: 768px) {
  .entity-edit-page {
    left: 8px;
    right: 8px;
    top: 120px;
    bottom: 8px;
  }
}

/* Standalone mode - full page */
.entity-edit-page.standalone {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 0;
  border: none;
}

/* ===================== TOPBAR ===================== */

.entity-edit-page .edit-topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
  color: white;
  flex-shrink: 0;
}

.entity-edit-page .topbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.entity-edit-page .topbar-left h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.entity-edit-page .topbar-left .legal-badge {
  background: rgba(255,255,255,0.2);
  padding: 4px 10px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
}

.entity-edit-page .topbar-left .tax-badge {
  background: rgba(255,255,255,0.15);
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
}

.entity-edit-page .topbar-left .activity-badge {
  font-size: 11px;
  opacity: 0.85;
}

.entity-edit-page .standalone-badge {
  background: rgba(255,255,255,0.2);
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}

.entity-edit-page .topbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.entity-edit-page .save-btn {
  padding: 8px 20px;
  background: rgba(255,255,255,0.2);
  border: 1px solid rgba(255,255,255,0.4);
  color: white;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 110px;
}

.entity-edit-page .save-btn:hover:not(:disabled) {
  background: rgba(255,255,255,0.35);
}

.entity-edit-page .save-btn:disabled {
  cursor: wait;
  opacity: 0.7;
}

.entity-edit-page .save-btn.saving {
  background: rgba(255,255,255,0.15);
  animation: entitySavingPulse 1s ease-in-out infinite;
}

@keyframes entitySavingPulse {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
}

.entity-edit-page .save-btn.success {
  background: rgba(16, 185, 129, 0.7);
  border-color: rgba(16, 185, 129, 0.9);
}

.entity-edit-page .close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.entity-edit-page .close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* ===================== BODY ===================== */

.entity-edit-page .edit-body {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px;
}

/* Wrapper for wizard styles */
.entity-edit-page .edit-body .wizard-add-entity {
  position: static;
  display: block;
  height: auto;
  width: 100%;
  background: transparent;
  overflow: visible;
}

/* Make exercice cards fit better */
.entity-edit-page .exercice-card {
  max-width: 100%;
  min-width: 0;
}

.entity-edit-page .wizard-add-entity .exercices-compact-list {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr) !important;
  flex-direction: unset !important;
  gap: 12px;
  align-items: start;
}

/* Responsive: 2 columns on medium screens, 1 on small */
@media (max-width: 1400px) {
  .entity-edit-page .wizard-add-entity .exercices-compact-list {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

@media (max-width: 900px) {
  .entity-edit-page .wizard-add-entity .exercices-compact-list {
    grid-template-columns: 1fr !important;
  }
}

/* Smaller exercice header for grid layout */
.entity-edit-page .exercice-header {
  padding: 6px 10px;
  gap: 6px;
}

.entity-edit-page .exercice-header strong {
  font-size: 11px;
}

/* Compact exercice body */
.entity-edit-page .exercice-body {
  padding: 6px;
}

/* Compact section rows - consistent height for ALL section types */
.entity-edit-page .wizard-add-entity .section-row {
  padding: 2px 8px !important;
  min-height: 22px !important;
  height: 22px !important;
  margin-bottom: 1px !important;
  align-items: baseline !important;
}

.entity-edit-page .wizard-add-entity .section-row.produits,
.entity-edit-page .wizard-add-entity .section-row.charges,
.entity-edit-page .wizard-add-entity .section-row.resultat-avant-is,
.entity-edit-page .wizard-add-entity .section-row.is-row,
.entity-edit-page .wizard-add-entity .section-row.resultat {
  padding: 2px 8px !important;
  min-height: 22px !important;
  height: 22px !important;
  margin-top: 2px !important;
  margin-bottom: 1px !important;
}

/* Affectation section - single line like Produits/Charges */
.entity-edit-page .wizard-add-entity .section-row.affectation {
  background: #F8FAFC !important;
  border-left: 3px solid #8B5CF6 !important;
}

.entity-edit-page .section-row.affectation .section-label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.entity-edit-page .section-row.affectation .section-value.affectation-inputs {
  display: flex;
  align-items: center;
  gap: 8px;
}

.entity-edit-page .affectation-inputs .input-group {
  display: flex;
  align-items: center;
  gap: 3px;
  background: rgba(139, 92, 246, 0.08);
  padding: 2px 6px;
  border-radius: 4px;
}

.entity-edit-page .affectation-inputs .input-label {
  font-size: 9px;
  color: #6B7280;
  font-weight: 500;
}

.entity-edit-page .affectation-inputs .date-input {
  width: 75px !important;
  height: 16px !important;
  font-size: 9px !important;
  padding: 1px 2px !important;
  border: 1px solid #D1D5DB !important;
  border-radius: 3px !important;
  background: white;
}

.entity-edit-page .affectation-inputs .pct-input {
  width: 28px !important;
  height: 16px !important;
  font-size: 10px !important;
  padding: 1px 3px !important;
  border: 1px solid #D1D5DB !important;
  border-radius: 3px !important;
  text-align: center;
  background: white;
}

/* Réserve légale row - styled as sub-row */
.entity-edit-page .line-row.reserve-legale-row {
  background: linear-gradient(90deg, #F3E8FF 0%, #FAF5FF 100%);
  border-left-color: #A855F7;
  padding: 1px 8px 1px 21px !important;
}

.entity-edit-page .plafond-badge {
  font-size: 8px;
  background: #A855F7;
  color: white;
  padding: 1px 4px;
  border-radius: 3px;
  margin-left: 4px;
}

/* Dividendes row - styled as sub-row */
.entity-edit-page .line-row.dividendes-row {
  background: linear-gradient(90deg, #FEF3C7 0%, #FFFBEB 100%);
  border-left-color: #F59E0B;
  padding: 1px 8px 1px 21px !important; /* Override WizardAddEntity.css */
}



.entity-edit-page .tax-year-badge {
  font-size: 8px;
  background: #F59E0B;
  color: white;
  padding: 1px 4px;
  border-radius: 3px;
  margin-left: 4px;
}

.entity-edit-page .line-row.dividendes-row .line-value,
.entity-edit-page .line-row.report-row .line-value,
.entity-edit-page .line-row.reserve-legale-row .line-value {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
}


.entity-edit-page .line-value .amount {
  font-weight: 600;
}

.entity-edit-page .line-value .amount.pos {
  color: #059669;
}

.entity-edit-page .line-value .amount.neg {
  color: #DC2626;
}

/* Report N-1 row - incoming from previous exercice */
.entity-edit-page .line-row.report-n1-row {
  background: linear-gradient(90deg, #FEE2E2 0%, #FEF2F2 100%);
  border-left-color: #F87171;
  font-style: italic;
}

/* Report à nouveau row - styled as sub-row */
.entity-edit-page .line-row.report-row {
  background: linear-gradient(90deg, #E0E7FF 0%, #EEF2FF 100%);
  border-left-color: #6366F1;
}

.entity-edit-page .report-hint {
  font-size: 8px;
  color: #6366F1;
  margin-left: 4px;
}

/* Exercice dates clipped by forecast period */
.entity-edit-page .exercice-header .periode {
  font-size: 10px;
  color: #64748B;
  margin-left: 6px;
}

.entity-edit-page .exercice-header .periode.clipped {
  color: #B45309;
  font-weight: 600;
}

.entity-edit-page .clip-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  padding: 3px 8px;
  background: #F59E0B;
  color: white;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  cursor: help;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(245, 158, 11, 0.3);
}

.entity-edit-page .clip-icon:hover {
  background: #D97706;
  transform: scale(1.05);
}

/* ===================== MODE SELECTOR (Simplifié/Détaillé) ===================== */

.entity-edit-page .mode-selector {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}

.entity-edit-page .mode-selector-label {
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
}

.entity-edit-page .mode-selector-cards {
  display: flex;
  gap: 6px;
}

.entity-edit-page .mode-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 8px 14px;
  border: 2px solid #E2E8F0;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
}

.entity-edit-page .mode-card:hover {
  border-color: #F59E0B;
  background: #FFFBEB;
}

.entity-edit-page .mode-card.selected {
  border-color: #F59E0B;
  background: #FEF3C7;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.25);
}

.entity-edit-page .mode-card-icon {
  font-size: 16px;
}

.entity-edit-page .mode-card-label {
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
}

.entity-edit-page .mode-card.selected .mode-card-label {
  color: #B45309;
}

/* ===================== CA DATES HEADER ===================== */

.entity-edit-page .ca-dates-header {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 10px 14px;
  background: white;
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}

.entity-edit-page .ca-dates-header.needs-end-date {
  border: 2px solid #F59E0B;
  background: #FFFBEB;
}

.entity-edit-page .ca-dates-header .date-field {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.entity-edit-page .ca-dates-header .date-field label {
  font-size: 10px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
}

.entity-edit-page .ca-dates-header .date-field label .required {
  color: #F59E0B;
  font-weight: 700;
}

.entity-edit-page .ca-dates-header .date-sep {
  font-size: 14px;
  color: #94A3B8;
  padding-bottom: 5px;
}

.entity-edit-page .source-date {
  padding: 6px 10px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 13px;
}

.entity-edit-page .source-date:focus {
  outline: none;
  border-color: #F59E0B;
}

.entity-edit-page .source-date.pulse {
  animation: pulse-border 1.5s ease-in-out infinite;
}

@keyframes pulse-border {
  0%, 100% { box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.4); }
  50% { box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.2); }
}

.entity-edit-page .empty-sources.waiting {
  background: #FFFBEB;
  border: 1px dashed #F59E0B;
  text-align: center;
  padding: 20px;
  border-radius: 8px;
}

.entity-edit-page .empty-sources .arrow-up {
  font-size: 24px;
  color: #F59E0B;
  display: block;
  margin-bottom: 8px;
  animation: bounce 1s ease-in-out infinite;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}

.entity-edit-page .empty-sources p {
  margin: 0;
  color: #64748B;
  font-size: 13px;
}

.entity-edit-page .empty-sources .empty-hint {
  display: block;
  margin-top: 6px;
  font-size: 11px;
  color: #94A3B8;
}

/* ===================== PORTAL MODALS ===================== */
/* Styles for modals rendered via portal to document.body */

.entity-edit-modal-portal .charges-var-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.6);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 99999;
  padding: 40px 20px;
  overflow-y: auto;
  animation: modalFadeIn 0.2s ease;
}

@keyframes modalFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.entity-edit-modal-portal .charges-var-modal {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 600px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: modalSlideIn 0.25s ease;
  margin: auto;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 80px);
}

.entity-edit-modal-portal .charges-var-modal.wide {
  max-width: 800px;
}

.entity-edit-modal-portal .charges-var-modal.extra-wide {
  max-width: 980px;
}

@keyframes modalSlideIn {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}

.entity-edit-modal-portal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
  color: white;
  border-radius: 16px 16px 0 0;
  flex-shrink: 0;
}

.entity-edit-modal-portal .modal-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
}

.entity-edit-modal-portal .modal-header .pcg-badge {
  background: rgba(255,255,255,0.2);
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
}

.entity-edit-modal-portal .modal-header .close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.entity-edit-modal-portal .modal-header .close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.entity-edit-modal-portal .modal-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1 1;
}

.entity-edit-modal-portal .modal-hint {
  font-size: 13px;
  color: #64748B;
  margin: 0 0 16px 0;
  padding: 10px 14px;
  background: #F8FAFC;
  border-radius: 8px;
  border-left: 3px solid #F59E0B;
}

.entity-edit-modal-portal .modal-hint .prorata-hint {
  color: #D97706;
  font-weight: 500;
}

.entity-edit-modal-portal .modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-top: 1px solid #E2E8F0;
  background: #FAFBFC;
  border-radius: 0 0 16px 16px;
  flex-shrink: 0;
}

.entity-edit-modal-portal .footer-hint {
  font-size: 11px;
  color: #94A3B8;
}

.entity-edit-modal-portal .footer-buttons {
  display: flex;
  gap: 10px;
}

.entity-edit-modal-portal .btn-cancel {
  padding: 8px 16px;
  border: 1px solid #E2E8F0;
  background: white;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
  color: #64748B;
}

.entity-edit-modal-portal .btn-cancel:hover {
  background: #F8FAFC;
}

.entity-edit-modal-portal .btn-save {
  padding: 8px 20px;
  border: none;
  background: linear-gradient(135deg, #F59E0B, #D97706);
  color: white;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.entity-edit-modal-portal .btn-save:hover {
  background: linear-gradient(135deg, #D97706, #B45309);
}

/* Charges summary table */
.entity-edit-modal-portal .charges-summary-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 16px;
}

.entity-edit-modal-portal .charges-summary-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #E2E8F0;
  font-size: 13px;
}

.entity-edit-modal-portal .charges-summary-table .neg {
  color: #DC2626;
  text-align: right;
  font-weight: 600;
}

.entity-edit-modal-portal .charges-summary-table .total-row td {
  background: #F8FAFC;
  font-weight: 600;
}

/* Charges table base */
.entity-edit-modal-portal .charges-table {
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 16px;
}

.entity-edit-modal-portal .charges-table .table-header {
  display: grid;
  grid-template-columns: 28px 1fr 70px 100px;
  gap: 8px;
  padding: 10px 14px;
  background: #F1F5F9;
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  border-bottom: 1px solid #E2E8F0;
}

.entity-edit-modal-portal .charges-table .table-body {
  background: white;
}

.entity-edit-modal-portal .charges-table .table-row {
  display: grid;
  grid-template-columns: 28px 1fr 70px 100px;
  gap: 8px;
  padding: 12px 14px;
  border-top: 1px solid #F1F5F9;
  align-items: center;
}

.entity-edit-modal-portal .charges-table .table-row:first-child {
  border-top: none;
}

.entity-edit-modal-portal .charges-table .table-row:hover {
  background: #FAFBFC;
}

.entity-edit-modal-portal .charges-table .table-row.enabled {
  background: #FFFBEB;
}

.entity-edit-modal-portal .charges-table .col-check input {
  width: 16px;
  height: 16px;
  accent-color: #F59E0B;
  cursor: pointer;
}

.entity-edit-modal-portal .charges-table .col-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #334155;
}

.entity-edit-modal-portal .charges-table .col-label .icon {
  font-size: 14px;
}

.entity-edit-modal-portal .charges-table .col-type select {
  padding: 5px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 11px;
  background: white;
}

.entity-edit-modal-portal .charges-table .col-amount input {
  width: 80px;
  padding: 6px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  text-align: right;
}

.entity-edit-modal-portal .charges-table .col-amount input:focus {
  outline: none;
  border-color: #F59E0B;
}

.entity-edit-modal-portal .charges-table .col-amount input:disabled {
  background: #F8FAFC;
  color: #94A3B8;
}

/* Simple grid for simplified mode */
.entity-edit-modal-portal .simple-grid {
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 16px;
}

.entity-edit-modal-portal .simple-grid .grid-row {
  display: grid;
  grid-template-columns: 1fr 200px;
  gap: 16px;
  padding: 12px 16px;
  align-items: center;
  cursor: pointer;
  transition: background 0.15s;
}

.entity-edit-modal-portal .simple-grid .grid-row:not(.header):hover {
  background: #F8FAFC;
}

.entity-edit-modal-portal .simple-grid .grid-row.header {
  background: #F8FAFC;
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  padding: 8px 16px;
  cursor: default;
}

.entity-edit-modal-portal .simple-grid .grid-row.selected {
  background: #FFFBEB;
}

.entity-edit-modal-portal .simple-grid .grid-row + .grid-row {
  border-top: 1px solid #E2E8F0;
}

.entity-edit-modal-portal .simple-grid .col-type {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #334155;
}

.entity-edit-modal-portal .simple-grid .col-type input[type="radio"] {
  width: 16px;
  height: 16px;
  accent-color: #F59E0B;
}

.entity-edit-modal-portal .simple-grid .col-value {
  display: flex;
  align-items: center;
  gap: 8px;
}

.entity-edit-modal-portal .simple-grid .col-value input {
  width: 100px;
  padding: 8px 10px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  text-align: right;
}

.entity-edit-modal-portal .simple-grid .col-value input:focus {
  outline: none;
  border-color: #F59E0B;
}

.entity-edit-modal-portal .simple-grid .col-value input:disabled {
  background: #F8FAFC;
  color: #94A3B8;
}

.entity-edit-modal-portal .simple-grid .col-value .unit {
  font-size: 12px;
  color: #64748B;
  min-width: 35px;
}

/* Mode toggle row */
.entity-edit-modal-portal .mode-toggle-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #E2E8F0;
}

.entity-edit-modal-portal .mode-toggle-row .mode-label {
  font-size: 12px;
  color: #64748B;
  font-weight: 500;
}

/* Impots table - grid layout */
.entity-edit-modal-portal .impots-table {
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 16px;
}

.entity-edit-modal-portal .impots-table .table-header {
  display: grid;
  grid-template-columns: 180px 1fr 140px 120px;
  gap: 8px;
  padding: 10px 14px;
  background: #F1F5F9;
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  border-bottom: 1px solid #E2E8F0;
}

.entity-edit-modal-portal .impots-table .table-body {
  background: white;
}

.entity-edit-modal-portal .impots-table .impot-row {
  display: grid;
  grid-template-columns: 180px 1fr 140px 120px;
  gap: 8px;
  padding: 14px;
  border-top: 1px solid #F1F5F9;
  align-items: start;
}

.entity-edit-modal-portal .impots-table .impot-row:first-child {
  border-top: none;
}

.entity-edit-modal-portal .impots-table .impot-row.disabled {
  opacity: 0.5;
  background: #FAFBFC;
}

.entity-edit-modal-portal .col-impot-label strong {
  display: block;
  font-size: 13px;
  color: #1E293B;
  margin-bottom: 2px;
}

.entity-edit-modal-portal .col-impot-label .impot-subtitle {
  font-size: 10px;
  color: #94A3B8;
}

.entity-edit-modal-portal .hypothesis-inputs {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.entity-edit-modal-portal .hypothesis-inputs .input-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.entity-edit-modal-portal .hypothesis-inputs .input-row label {
  font-size: 11px;
  color: #64748B;
  min-width: 80px;
}

.entity-edit-modal-portal .input-with-suffix {
  display: flex;
  align-items: center;
  gap: 4px;
}

.entity-edit-modal-portal .input-with-suffix input {
  width: 70px;
  padding: 6px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 12px;
  text-align: right;
}

.entity-edit-modal-portal .input-with-suffix input:focus {
  outline: none;
  border-color: #F59E0B;
}

.entity-edit-modal-portal .input-with-suffix span {
  font-size: 11px;
  color: #64748B;
  min-width: 20px;
}

.entity-edit-modal-portal .mode-toggle {
  display: flex;
  gap: 2px;
  padding: 2px;
  background: #F1F5F9;
  border-radius: 6px;
}

.entity-edit-modal-portal .mode-toggle.compact {
  padding: 1px;
}

.entity-edit-modal-portal .mode-toggle button {
  padding: 5px 10px;
  border: none;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  background: transparent;
  color: #64748B;
  transition: all 0.15s;
}

.entity-edit-modal-portal .mode-toggle button.active {
  background: white;
  color: #1E293B;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.entity-edit-modal-portal .calcul-stack {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.entity-edit-modal-portal .calcul-formula {
  font-size: 10px;
  color: #64748B;
  font-family: monospace;
}

.entity-edit-modal-portal .calcul-formula.positive {
  color: #16A34A;
  font-weight: 600;
}

.entity-edit-modal-portal .calcul-note.warning {
  color: #D97706;
  font-weight: 500;
}

.entity-edit-modal-portal .editable-amount {
  display: flex;
  align-items: center;
  gap: 4px;
}

.entity-edit-modal-portal .editable-amount .amount-input {
  width: 80px;
  padding: 6px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  text-align: right;
}

.entity-edit-modal-portal .editable-amount .amount-input:focus {
  outline: none;
  border-color: #F59E0B;
}

.entity-edit-modal-portal .editable-amount .currency {
  font-size: 12px;
  color: #64748B;
}

.entity-edit-modal-portal .editable-amount .btn-reset {
  background: #FEF3C7;
  border: none;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: #D97706;
}

.entity-edit-modal-portal .calc-indicator {
  font-size: 10px;
  color: #16A34A;
  font-weight: 500;
  margin-left: 4px;
}

.entity-edit-modal-portal .not-applicable {
  font-size: 11px;
  color: #94A3B8;
  font-style: italic;
}

.entity-edit-modal-portal .info-line {
  font-size: 10px;
  color: #64748B;
}

.entity-edit-modal-portal .impot-rules-help {
  background: #F0FDF4;
  border: 1px solid #BBF7D0;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 16px;
}

.entity-edit-modal-portal .impot-rules-help .rule-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 12px;
  color: #166534;
  margin-bottom: 8px;
}

.entity-edit-modal-portal .impot-rules-help .rule-item:last-child {
  margin-bottom: 0;
}

.entity-edit-modal-portal .impot-rules-help .rule-icon {
  font-size: 14px;
}

.entity-edit-modal-portal .modal-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  background: linear-gradient(135deg, #FEF3C7, #FDE68A);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #92400E;
}

/* Tooltip */
.entity-edit-modal-portal .help-icon {
  font-size: 12px;
  color: #94A3B8;
  cursor: help;
}

/* Personnel table */
.entity-edit-modal-portal .personnel-section {
  margin-bottom: 20px;
  padding: 16px;
  background: #F8FAFC;
  border-radius: 10px;
  border: 1px solid #E2E8F0;
}

.entity-edit-modal-portal .personnel-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.entity-edit-modal-portal .personnel-section h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #1E293B;
}

.entity-edit-modal-portal .personnel-table .table-header {
  display: grid;
  grid-template-columns: 85px 130px 55px 95px 50px 100px 110px 95px 95px 30px;
  /* Fonction | Personne | Statut | Brut/mois | Mois | Début rém. | Brut annuel | Charges pat. | Coût total | Actions */
  gap: 8px;
  padding: 10px 14px;
  background: #E2E8F0;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  margin-bottom: 8px;
  white-space: nowrap;
}

.entity-edit-modal-portal .personnel-table .personnel-row,
.entity-edit-modal-portal .personnel-table .table-row {
  display: grid;
  grid-template-columns: 85px 130px 55px 95px 50px 100px 110px 95px 95px 30px;
  /* Fonction | Personne | Statut | Brut/mois | Mois | Début rém. | Brut annuel | Charges pat. | Coût total | Actions */
  gap: 8px;
  padding: 12px 14px;
  background: white;
  border-radius: 6px;
  margin-bottom: 6px;
  align-items: center;
  font-size: 12px;
}

/* Detailed mode (employees) - name column is wider */
.entity-edit-modal-portal .personnel-table.detailed .table-header,
.entity-edit-modal-portal .personnel-table.detailed .table-row {
  grid-template-columns: 180px 120px 60px 60px 110px 100px 30px;
  /* Poste/Nom | Brut/mois | Mois | Effectif | Charges pat. | Coût annuel | Actions */
}

.entity-edit-modal-portal .personnel-table .role-name {
  font-weight: 600;
  color: #1E293B;
}

.entity-edit-modal-portal .personnel-table .status-tag {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
}

.entity-edit-modal-portal .personnel-table .status-tag.tns {
  background: #DBEAFE;
  color: #1D4ED8;
}

.entity-edit-modal-portal .personnel-table .status-tag.as {
  background: #F3E8FF;
  color: #7C3AED;
}

.entity-edit-modal-portal .personnel-table .months-input,
.entity-edit-modal-portal .personnel-table .count-input {
  width: 45px;
  padding: 5px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  text-align: center;
  font-size: 12px;
}

.entity-edit-modal-portal .personnel-table .charges-value {
  font-size: 11px;
  color: #DC2626;
}

.entity-edit-modal-portal .personnel-table .charges-rate {
  font-size: 9px;
  color: #94A3B8;
  display: block;
}

.entity-edit-modal-portal .personnel-table .non-remunere {
  font-size: 11px;
  color: #94A3B8;
  font-style: italic;
}

.entity-edit-modal-portal .personnel-table .col-personnel-annual {
  text-align: right;
}

.entity-edit-modal-portal .personnel-table .annual-value {
  font-weight: 600;
  color: #1E293B;
  font-size: 11px;
}

.entity-edit-modal-portal .personnel-table .prorata-badge {
  display: inline-block;
  background: #FEF3C7;
  color: #92400E;
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
  margin-left: 4px;
  cursor: help;
}

.entity-edit-modal-portal .personnel-table .tag-reduction {
  background: #DCFCE7;
  color: #166534;
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 8px;
  font-weight: 600;
  margin-left: 4px;
}

.entity-edit-modal-portal .btn-remove {
  background: #FEE2E2;
  border: none;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  cursor: pointer;
  color: #DC2626;
  font-size: 14px;
}

.entity-edit-modal-portal .btn-add-manager,
.entity-edit-modal-portal .btn-add-employee {
  padding: 8px 14px;
  border: 1px dashed #D97706;
  background: #FFFBEB;
  border-radius: 6px;
  color: #D97706;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 8px;
}

.entity-edit-modal-portal .no-data {
  font-size: 12px;
  color: #94A3B8;
  font-style: italic;
  text-align: center;
  padding: 16px;
}

.entity-edit-modal-portal .toggle-checkbox {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #64748B;
  cursor: pointer;
}

.entity-edit-modal-portal .header-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.entity-edit-modal-portal .modal-legend {
  display: flex;
  gap: 20px;
  padding: 10px 14px;
  background: #F8FAFC;
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: 11px;
  color: #64748B;
}

.entity-edit-modal-portal .legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.entity-edit-modal-portal .legend-input {
  width: 16px;
  height: 16px;
  border: 1px solid #E2E8F0;
  border-radius: 3px;
  background: white;
}

.entity-edit-modal-portal .legend-calc {
  width: 16px;
  height: 16px;
  background: #F1F5F9;
  border-radius: 3px;
}

/* Charge detail sections */
.entity-edit-modal-portal .charge-detail-section {
  margin-bottom: 16px;
  padding: 14px;
  background: white;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
}

.entity-edit-modal-portal .charge-detail-section h5 {
  margin: 0 0 12px 0;
  font-size: 13px;
  font-weight: 600;
  color: #1E293B;
  padding-bottom: 8px;
  border-bottom: 1px solid #E2E8F0;
}

.entity-edit-modal-portal .charges-config-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.entity-edit-modal-portal .config-label {
  font-size: 12px;
  color: #64748B;
  min-width: 150px;
}

.entity-edit-modal-portal .config-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}

.entity-edit-modal-portal .config-inputs select {
  padding: 5px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 11px;
}

.entity-edit-modal-portal .config-inputs input {
  width: 60px;
  padding: 5px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  text-align: right;
}

.entity-edit-modal-portal .config-inputs .suffix {
  font-size: 11px;
  color: #64748B;
}

.entity-edit-modal-portal .config-result {
  font-size: 12px;
  font-weight: 600;
  color: #1E293B;
}

.entity-edit-modal-portal .charge-total-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 14px;
  background: #FEF3C7;
  border-radius: 8px;
  font-size: 13px;
  margin-top: 16px;
}

.entity-edit-modal-portal .charge-total-row .neg {
  color: #DC2626;
}

.entity-edit-modal-portal .info-text {
  font-size: 12px;
  color: #94A3B8;
  font-style: italic;
  padding: 10px;
  text-align: center;
}

/* Tooltip portal styles */
.tooltip-portal {
  pointer-events: none;
}

.tooltip-content-portal {
  background: #1E293B;
  color: white;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 11px;
  max-width: 200px;
  white-space: normal;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.tooltip-content-portal::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #1E293B;
}

.tooltip-trigger {
  cursor: help;
}

/* Empty row styles */
.entity-edit-modal-portal .empty-row {
  padding: 20px;
  text-align: center;
}

.entity-edit-modal-portal .empty-message {
  color: #94A3B8;
  font-style: italic;
  font-size: 12px;
  grid-column: 1 / -1;
}

/* Add row styles */
.entity-edit-modal-portal .add-row {
  background: transparent !important;
  padding: 8px 12px !important;
}

.entity-edit-modal-portal .add-cell {
  grid-column: 1 / -1;
}

/* Input name for detailed employee profiles */
.entity-edit-modal-portal .input-name {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
}

.entity-edit-modal-portal .input-name:focus {
  outline: none;
  border-color: #F59E0B;
}

/* No data muted state */
.entity-edit-modal-portal .no-data.muted {
  color: #CBD5E1;
}

/* Modal add button style */
.entity-edit-modal-portal .btn-add-manager.modal-add,
.entity-edit-modal-portal .btn-add-employee.modal-add {
  width: 100%;
  margin-top: 12px;
}

/* CFE row specific styling */
.entity-edit-modal-portal .cfe-row .impot-ca-info {
  margin-top: 4px;
}

/* Calcul formula muted state */
.entity-edit-modal-portal .calcul-formula.muted {
  color: #CBD5E1;
}

/* Toggle row in hypothesis inputs */
.entity-edit-modal-portal .toggle-row {
  margin-bottom: 4px;
}

/* Input with suffix - ensure proper sizing */
.entity-edit-modal-portal .input-with-suffix {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.entity-edit-modal-portal .input-with-suffix input {
  width: 70px;
  padding: 6px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 12px;
  text-align: right;
}

.entity-edit-modal-portal .input-with-suffix input:focus {
  outline: none;
  border-color: #F59E0B;
}

.entity-edit-modal-portal .input-with-suffix span {
  font-size: 11px;
  color: #64748B;
  min-width: 15px;
}

/* Personnel table column widths */
.entity-edit-modal-portal .col-personnel-role {
  min-width: 70px;
}

.entity-edit-modal-portal .col-personnel-person {
  min-width: 130px;
}

.entity-edit-modal-portal .col-personnel-person .person-select {
  width: 100%;
  padding: 4px 6px;
  font-size: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
}

.entity-edit-modal-portal .col-personnel-person .person-select:focus {
  border-color: #3B82F6;
  outline: none;
}

.entity-edit-modal-portal .col-personnel-status {
  text-align: center;
}

.entity-edit-modal-portal .col-personnel-brut {
  min-width: 90px;
}

.entity-edit-modal-portal .col-personnel-months {
  text-align: center;
}

.entity-edit-modal-portal .col-personnel-salary-start {
  text-align: center;
}

.entity-edit-modal-portal .col-personnel-salary-start input {
  width: 100%;
  max-width: 82px;
  padding: 4px 3px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 10px;
  text-align: center;
  background: white;
}

.entity-edit-modal-portal .col-personnel-salary-start input:focus {
  outline: none;
  border-color: #F59E0B;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.1);
}

.entity-edit-modal-portal .col-personnel-salary-start input.locked,
.entity-edit-modal-portal .col-personnel-salary-start input:disabled {
  background: #F1F5F9;
  color: #64748B;
  cursor: not-allowed;
  border-color: #CBD5E1;
}

.entity-edit-modal-portal .col-personnel-count {
  text-align: center;
}

.entity-edit-modal-portal .col-personnel-charges {
  text-align: right;
}

.entity-edit-modal-portal .col-personnel-cout {
  text-align: right;
  font-weight: 600;
}

.entity-edit-modal-portal .col-personnel-actions {
  text-align: center;
}

.entity-edit-modal-portal .col-personnel-name {
  min-width: 120px;
}

/* ==================== ADD PRODUCTS BUTTONS ==================== */

.entity-edit-page .add-row.products-add {
  display: flex;
  gap: 8px;
  padding: 6px 12px;
  background: #F8FAFC;
  border-radius: 4px;
  margin: 4px 0;
}

.entity-edit-page .add-row.products-add button {
  padding: 4px 10px;
  font-size: 11px;
  background: white;
  border: 1px dashed #CBD5E1;
  border-radius: 4px;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s;
}

.entity-edit-page .add-row.products-add button:hover {
  border-color: #F59E0B;
  color: #F59E0B;
  background: #FFF9E6;
}

/* ============================================
   EXERCICE ROWS - NEW DESIGN SYSTEM
   ============================================ */

/* Base section row */
.entity-edit-page .section-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
  min-height: 28px;
  border-radius: 4px;
  margin-bottom: 2px;
}

.entity-edit-page .section-label {
  display: flex;
  align-items: baseline;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  color: #1E293B;
}

.entity-edit-page .section-label .icon {
  width: 16px;
  text-align: center;
  font-weight: 700;
  font-size: 14px;
  color: #6B7280;
  flex-shrink: 0;
}

.entity-edit-page .section-label .pcg-num {
  display: inline-block;
  width: 28px;
  text-align: right;
  font-family: 'SF Mono', Monaco, Consolas, monospace;
  font-size: 10px;
  font-weight: 600;
  color: #6B7280;
  flex-shrink: 0;
  margin-right: 6px;
}

.entity-edit-page .wizard-add-entity .section-value {
  font-size: 12px;
  font-weight: 700;
  color: #1E293B;
  text-align: right;
}

.entity-edit-page .section-value.neg {
  color: #DC2626;
}

/* PRODUITS - Vert pâle (entrées) */
.entity-edit-page .section-row.produits {
  background: #ECFDF5;
  border: 1px solid #A7F3D0;
}

.entity-edit-page .section-row.produits .section-label {
  color: #065F46;
}

.entity-edit-page .section-row.produits .section-value {
  color: #059669;
}

/* CHARGES - Rose pâle (sorties) */
.entity-edit-page .section-row.charges {
  background: #FEF2F2;
  border: 1px solid #FECACA;
  margin-top: 8px;
}

.entity-edit-page .section-row.charges .section-label {
  color: #991B1B;
}

.entity-edit-page .section-row.charges .section-value {
  color: #DC2626;
}

.entity-edit-page .section-row.charges.clickable {
  cursor: pointer;
  transition: all 0.15s ease;
}

.entity-edit-page .section-row.charges.clickable:hover {
  background: #FEE2E2;
  border-color: #F87171;
}

.entity-edit-page .section-row.charges .expand-hint {
  font-size: 10px;
  font-weight: 400;
  color: #9CA3AF;
  margin-left: 8px;
}

/* RÉSULTAT AVANT IS - Gris neutre */
.entity-edit-page .section-row.resultat-avant-is {
  background: #F1F5F9;
  border: 1px solid #E2E8F0;
  margin-top: 8px;
}

/* IS - Ambre pâle (taxe) */
.entity-edit-page .section-row.is-row {
  background: #FEF9C3;
  border: 1px solid #FDE047;
}

.entity-edit-page .section-row.is-row .is-rate {
  font-size: 10px;
  font-weight: 400;
  color: #A16207;
  margin-left: 4px;
}

.entity-edit-page .section-row.is-row .section-value {
  color: #A16207;
}

/* RÉSULTAT NET - Fort contraste */
.entity-edit-page .section-row.resultat {
  margin-top: 8px;
  border-width: 2px;
}

.entity-edit-page .section-row.resultat.pos {
  background: #D1FAE5;
  border: 2px solid #059669;
}

.entity-edit-page .section-row.resultat.pos .section-value {
  color: #059669;
}

.entity-edit-page .section-row.resultat.neg {
  background: #FEE2E2;
  border: 2px solid #DC2626;
}

.entity-edit-page .section-row.resultat.neg .section-value {
  color: #DC2626;
}

/* ============================================
   LINE ROWS - Sous-lignes détail
   ============================================ */

.entity-edit-page .line-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1px 8px 1px 21px;
  min-height: 20px;
  height: 20px;
  background: #FAFAFA;
  border-left: 3px solid transparent;
  margin-left: 10px;
  margin-bottom: 1px;
  border-radius: 3px;
}

.entity-edit-page .line-row.ca {
  border-left-color: #10B981;
  background: #F0FDF4;
}

/* Make CA inputs blend with line-row style */
.entity-edit-page .line-row.ca .label-input {
  background: transparent !important;
  border: none !important;
  font-size: 10px !important;
  padding: 0 !important;
  color: #374151 !important;
}

.entity-edit-page .line-row.ca .label-input:focus {
  outline: none !important;
  background: rgba(255,255,255,0.5) !important;
}

.entity-edit-page .line-row.ca .line-input input {
  background: rgba(255,255,255,0.6) !important;
  border: 1px solid #A7F3D0 !important;
  font-size: 10px !important;
  padding: 1px 4px !important;
  width: 65px !important;
  height: 16px !important;
  border-radius: 3px !important;
}

.entity-edit-page .line-row.charge-line {
  border-left-color: #F87171;
  background: #FEF2F2;
}

.entity-edit-page .wizard-add-entity .line-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 10px;
  color: #374151;
}

.entity-edit-page .wizard-add-entity .line-label .pcg-num {
  display: inline-flex;
  justify-content: flex-start;
  width: 36px !important;
  min-width: 36px !important;
  text-align: left !important;
  font-family: 'SF Mono', Monaco, Consolas, monospace;
  font-size: 10px;
  font-weight: 600;
  color: #6B7280;
  flex-shrink: 0;
  margin-right: 6px;
}

.entity-edit-page .line-input {
  display: flex;
  align-items: center;
  gap: 4px;
}

.entity-edit-page .line-input input {
  width: 80px;
  padding: 4px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
  background: #F9FAFB;
}

.entity-edit-page .line-input input:focus {
  outline: none;
  border-color: #3B82F6;
  background: white;
}

.entity-edit-page .line-input span {
  font-size: 11px;
  color: #9CA3AF;
}

.entity-edit-page .line-value-with-btn {
  display: flex;
  align-items: center;
  gap: 6px;
}

.entity-edit-page .line-value-with-btn span {
  font-size: 12px;
  font-weight: 600;
  min-width: 80px;
  text-align: right;
}

.entity-edit-page .line-value-with-btn span.neg {
  color: #DC2626;
}

.entity-edit-page .mini-btn {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid #E2E8F0;
  background: #F9FAFB;
  color: #64748B;
  font-size: 11px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.entity-edit-page .mini-btn:hover {
  background: #E2E8F0;
  color: #374151;
}

.entity-edit-page .mini-btn.info:hover {
  background: #DBEAFE;
  border-color: #3B82F6;
  color: #3B82F6;
}

/* Mini tags */
.entity-edit-page .mini-tag {
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
}

.entity-edit-page .mini-tag.exo {
  background: #D1FAE5;
  color: #059669;
}

.entity-edit-page .mini-tag.reduc {
  background: #FEF3C7;
  color: #D97706;
}

.entity-edit-page .mini-tag.cvae {
  background: #DBEAFE;
  color: #2563EB;
}

/* Add row buttons */
.entity-edit-page .add-row {
  display: flex;
  gap: 6px;
  padding: 4px 12px 4px 24px;
}

.entity-edit-page .add-row button {
  padding: 3px 8px;
  font-size: 10px;
  border: 1px dashed #D1D5DB;
  background: transparent;
  border-radius: 4px;
  color: #6B7280;
  cursor: pointer;
}

.entity-edit-page .add-row button:hover {
  border-color: #3B82F6;
  color: #3B82F6;
  background: #EFF6FF;
}

/* CA Secondary row styling */
.entity-edit-page .line-row.ca.secondary {
  background: #F0FDF4;
}

.entity-edit-page .line-row.ca.secondary .line-label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.entity-edit-page .line-row.ca.secondary .label-input {
  flex: 1 1;
  min-width: 80px;
  max-width: 150px;
}

/* Clickable personnel line */
.entity-edit-page .line-row.clickable-line {
  cursor: pointer;
  transition: background-color 0.2s;
  border-radius: 4px;
}

.entity-edit-page .line-row.clickable-line:hover {
  background-color: rgba(59, 130, 246, 0.08);
}

.entity-edit-page .linked-indicator {
  margin-left: 8px;
  display: inline-flex;
  gap: 6px;
  align-items: center;
}

.entity-edit-page .linked-badge {
  font-size: 10px;
  padding: 2px 6px;
  background: #DCFCE7;
  color: #166534;
  border-radius: 10px;
  white-space: nowrap;
}

.entity-edit-page .unlinked-badge {
  font-size: 10px;
  padding: 2px 6px;
  background: #FEF3C7;
  color: #92400E;
  border-radius: 10px;
  white-space: nowrap;
}

/* Clickable table row in modal */
.entity-edit-page tr.clickable-row {
  cursor: pointer;
  transition: background-color 0.2s;
}

.entity-edit-page tr.clickable-row:hover {
  background-color: rgba(59, 130, 246, 0.1);
}

.entity-edit-page .linked-indicator-inline {
  margin-left: 8px;
  display: inline-flex;
  gap: 4px;
}

.entity-edit-page .linked-badge-sm,
.entity-edit-page .unlinked-badge-sm {
  font-size: 9px;
  padding: 1px 5px;
  border-radius: 8px;
}

.entity-edit-page .linked-badge-sm {
  background: #DCFCE7;
  color: #166534;
}

.entity-edit-page .unlinked-badge-sm {
  background: #FEF3C7;
  color: #92400E;
}

/* Mini remove button */
.entity-edit-page .mini-btn.remove {
  background: transparent;
  border: none;
  color: #EF4444;
  cursor: pointer;
  padding: 2px 6px;
  font-size: 14px;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.entity-edit-page .mini-btn.remove:hover {
  opacity: 1;
}

/* ===================== HYPOTHESIS EDITING ===================== */

.entity-edit-page .hypotheses-section-title {
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.entity-edit-page .step2-summary {
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.entity-edit-page .step2-summary:not(.editing):hover {
  background: #FFF9E6;
  border-color: #F59E0B;
}

.entity-edit-page .step2-summary.editing {
  cursor: default;
  border-radius: 8px;
  border: 2px solid #F59E0B;
  padding: 16px;
  padding-right: 40px;
  background: white;
}

.entity-edit-page .step2-summary .summary-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 4px;
}

.entity-edit-page .step2-summary .summary-header.editing-header {
  justify-content: center;
  margin-bottom: 10px;
}

.entity-edit-page .step2-summary .summary-header .summary-label {
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.entity-edit-page .step2-summary .summary-header .summary-label-center {
  font-size: 12px;
  font-weight: 700;
  color: #1E293B;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Action buttons container for hypothesis section - top right */
.entity-edit-page .step2-summary .hyp-action-buttons {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 10;
}

/* Single action button for hypothesis section - top right */
.entity-edit-page .step2-summary .hyp-action-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.entity-edit-page .step2-summary > .hyp-action-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
}

.entity-edit-page .step2-summary .hyp-action-btn.close {
  padding: 4px 8px;
  background: #E2E8F0;
  color: #64748B;
  font-size: 16px;
  font-weight: 400;
  line-height: 1;
}

.entity-edit-page .step2-summary .hyp-action-btn.close:hover {
  background: #CBD5E1;
  color: #475569;
}

.entity-edit-page .step2-summary .hyp-action-btn.modifier {
  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
  color: white;
  box-shadow: 0 2px 4px rgba(245, 158, 11, 0.3);
}

.entity-edit-page .step2-summary .hyp-action-btn.modifier:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(245, 158, 11, 0.4);
  background: linear-gradient(135deg, #FBBF24 0%, #F59E0B 100%);
}

.entity-edit-page .step2-summary .hyp-action-btn.appliquer {
  background: linear-gradient(135deg, #10B981 0%, #059669 100%);
  color: white;
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.3);
}

.entity-edit-page .step2-summary .hyp-action-btn.appliquer:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(16, 185, 129, 0.4);
  background: linear-gradient(135deg, #34D399 0%, #10B981 100%);
}

.entity-edit-page .step2-summary .hyp-action-btn .btn-icon {
  font-size: 14px;
}

.entity-edit-page .step2-summary .hyp-action-btn .btn-text {
  font-size: 12px;
}

/* Compact summary content - single line */
.entity-edit-page .step2-summary .summary-content-compact {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  padding-right: 100px; /* Space for button */
}

.entity-edit-page .step2-summary .summary-content-compact .summary-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #475569;
}

.entity-edit-page .step2-summary .summary-content-compact .summary-item strong {
  color: #1E293B;
}

.entity-edit-page .step2-summary .summary-content-compact .summary-item em {
  color: #64748B;
  font-style: normal;
}

.entity-edit-page .step2-summary .summary-content-compact .status-badge {
  font-size: 9px;
  padding: 2px 5px;
  border-radius: 3px;
  font-weight: 600;
}

.entity-edit-page .step2-summary .summary-content-compact .status-badge.tns {
  background: #DBEAFE;
  color: #1D4ED8;
}

.entity-edit-page .step2-summary .summary-content-compact .status-badge.as {
  background: #F3E8FF;
  color: #7C3AED;
}

.entity-edit-page .step2-summary .summary-content-compact .summary-tag {
  font-size: 9px;
  padding: 2px 6px;
  border-radius: 3px;
  font-weight: 600;
  background: #D1FAE5;
  color: #065F46;
}

.entity-edit-page .step2-summary .summary-content-compact .summary-tag.jei {
  background: #FEF3C7;
  color: #92400E;
}

.entity-edit-page .step2-summary .summary-content-compact .summary-tag.tva {
  background: #E0E7FF;
  color: #3730A3;
}

/* Hypothesis edit form - 2 rows layout */
.entity-edit-page .hypotheses-edit-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 10px;
  border-top: 1px solid #E2E8F0;
}

.entity-edit-page .hypotheses-edit-form .hyp-row {
  display: flex;
  gap: 12px;
}

.entity-edit-page .hypotheses-edit-form .edit-section {
  background: #F8FAFC;
  padding: 10px 14px;
  border-radius: 6px;
  border: 1px solid #E2E8F0;
  flex: 1 1;
}

.entity-edit-page .hypotheses-edit-form .edit-section h4 {
  margin: 0 0 8px 0;
  font-size: 10px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Dirigeants section */
.entity-edit-page .hypotheses-edit-form .dirigeants-section {
  flex: 1.5 1;
}

.entity-edit-page .hypotheses-edit-form .dirigeants-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.entity-edit-page .hypotheses-edit-form .manager-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  background: white;
  border-radius: 4px;
  border: 1px solid #E2E8F0;
}

.entity-edit-page .hypotheses-edit-form .manager-row .manager-label {
  font-weight: 600;
  font-size: 12px;
  color: #334155;
  min-width: 75px;
}

.entity-edit-page .hypotheses-edit-form .manager-row input {
  width: 70px;
  padding: 5px 8px;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  font-size: 13px;
  text-align: right;
}

.entity-edit-page .hypotheses-edit-form .manager-row input.small-input {
  width: 50px;
}

.entity-edit-page .hypotheses-edit-form .manager-row input:focus {
  outline: none;
  border-color: #F59E0B;
}

.entity-edit-page .hypotheses-edit-form .manager-row .unit {
  font-size: 11px;
  color: #64748B;
  min-width: 40px;
}

.entity-edit-page .hypotheses-edit-form .manager-row .status-badge {
  font-size: 10px;
  padding: 3px 8px;
  border-radius: 4px;
  font-weight: 600;
}

.entity-edit-page .hypotheses-edit-form .manager-row .status-badge.tns {
  background: #DBEAFE;
  color: #1D4ED8;
}

.entity-edit-page .hypotheses-edit-form .manager-row .status-badge.as {
  background: #F3E8FF;
  color: #7C3AED;
}

.entity-edit-page .hypotheses-edit-form .add-btn {
  background: transparent;
  border: 1px dashed #CBD5E1;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 11px;
  color: #64748B;
  cursor: pointer;
  margin-top: 6px;
}

.entity-edit-page .hypotheses-edit-form .add-btn:hover {
  border-color: #F59E0B;
  color: #F59E0B;
}

/* Employés section */
.entity-edit-page .hypotheses-edit-form .employes-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.entity-edit-page .hypotheses-edit-form .employes-row label {
  font-size: 12px;
  color: #64748B;
}

.entity-edit-page .hypotheses-edit-form .employes-row .toggle-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  cursor: pointer;
}

.entity-edit-page .hypotheses-edit-form .employes-row input[type="checkbox"] {
  width: 14px;
  height: 14px;
  accent-color: #F59E0B;
}

.entity-edit-page .hypotheses-edit-form .employes-row input[type="number"] {
  width: 70px;
  padding: 5px 8px;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  font-size: 13px;
  text-align: right;
}

.entity-edit-page .hypotheses-edit-form .employes-row input[type="number"].small-input {
  width: 50px;
}

.entity-edit-page .hypotheses-edit-form .employes-row input[type="number"]:focus {
  outline: none;
  border-color: #F59E0B;
}

.entity-edit-page .hypotheses-edit-form .employes-row .separator {
  color: #CBD5E1;
}

.entity-edit-page .hypotheses-edit-form .employes-row .unit {
  font-size: 11px;
  color: #64748B;
}

/* Charges section */
.entity-edit-page .hypotheses-edit-form .charges-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.entity-edit-page .hypotheses-edit-form .charges-mode-toggle {
  display: inline-flex;
}

.entity-edit-page .hypotheses-edit-form .charges-mode-toggle button {
  padding: 5px 10px;
  border: 1px solid #CBD5E1;
  background: white;
  font-size: 11px;
  cursor: pointer;
}

.entity-edit-page .hypotheses-edit-form .charges-mode-toggle button:first-child {
  border-radius: 4px 0 0 4px;
  border-right: none;
}

.entity-edit-page .hypotheses-edit-form .charges-mode-toggle button:last-child {
  border-radius: 0 4px 4px 0;
}

.entity-edit-page .hypotheses-edit-form .charges-mode-toggle button.active {
  background: #F59E0B;
  border-color: #F59E0B;
  color: white;
}

.entity-edit-page .hypotheses-edit-form .charges-row input {
  width: 80px;
  padding: 5px 8px;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  font-size: 13px;
  text-align: right;
}

.entity-edit-page .hypotheses-edit-form .charges-row input:focus {
  outline: none;
  border-color: #F59E0B;
}

.entity-edit-page .hypotheses-edit-form .charges-row .unit {
  font-size: 11px;
  color: #64748B;
}

/* Options section */
.entity-edit-page .hypotheses-edit-form .options-row {
  display: flex;
  gap: 16px;
}

.entity-edit-page .hypotheses-edit-form .option-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  cursor: pointer;
}

.entity-edit-page .hypotheses-edit-form .option-toggle input[type="checkbox"] {
  width: 14px;
  height: 14px;
  accent-color: #F59E0B;
}

.entity-edit-page .hypotheses-edit-form .option-hint {
  font-size: 10px;
  color: #94A3B8;
  font-weight: 400;
}

/* TVA select */
.entity-edit-page .hypotheses-edit-form .tva-row {
  display: flex;
  align-items: center;
}

.entity-edit-page .hypotheses-edit-form .tva-select {
  padding: 6px 10px;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  font-size: 12px;
  background: white;
  cursor: pointer;
  min-width: 180px;
}

.entity-edit-page .hypotheses-edit-form .tva-select:focus {
  outline: none;
  border-color: #F59E0B;
}

/* Dividend row */
.entity-edit-page .hypotheses-edit-form .dividend-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.entity-edit-page .hypotheses-edit-form .dividend-row label {
  font-size: 12px;
  color: #64748B;
}

.entity-edit-page .hypotheses-edit-form .dividend-row input {
  width: 60px;
  padding: 5px 8px;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  font-size: 13px;
  text-align: right;
}

.entity-edit-page .hypotheses-edit-form .dividend-row input:focus {
  outline: none;
  border-color: #F59E0B;
}

/* Capital row */
.entity-edit-page .hypotheses-edit-form .capital-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.entity-edit-page .hypotheses-edit-form .capital-row input {
  width: 100px;
  padding: 5px 8px;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  font-size: 13px;
  text-align: right;
}

.entity-edit-page .hypotheses-edit-form .capital-row input:focus {
  outline: none;
  border-color: #F59E0B;
}

.entity-edit-page .hypotheses-edit-form .medium-input {
  width: 100px !important;
}

/* SARL dividend warning */
.entity-edit-page .hypotheses-edit-form .sarl-dividend-warning {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 8px;
  padding: 8px 10px;
  background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%);
  border: 1px solid #F59E0B;
  border-radius: 6px;
  font-size: 11px;
  line-height: 1.4;
}

.entity-edit-page .hypotheses-edit-form .sarl-dividend-warning .warning-icon {
  flex-shrink: 0;
  font-size: 14px;
}

.entity-edit-page .hypotheses-edit-form .sarl-dividend-warning .warning-text {
  color: #92400E;
}

.entity-edit-page .hypotheses-edit-form .sarl-dividend-warning .warning-text strong {
  color: #78350F;
}

/* Dividend info in exercice card */
.entity-edit-page .section-row.dividend-info {
  background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%);
  border-radius: 6px;
  padding: 8px 12px;
  margin-top: 8px;
  border: 1px solid #F59E0B40;
}

.entity-edit-page .section-row.dividend-info .section-label {
  color: #92400E;
}

.entity-edit-page .section-row.dividend-info .section-label .icon {
  font-size: 14px;
}

.entity-edit-page .section-row.dividend-info .section-value {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  color: #92400E;
  font-weight: 600;
}

.entity-edit-page .section-row.dividend-info .dividend-timing {
  font-size: 11px;
  font-weight: 400;
  color: #B45309;
}

.entity-edit-page .section-row.dividend-info .dividend-timing .tax-year {
  margin-left: 4px;
  padding: 1px 6px;
  background: #F59E0B;
  color: white;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 600;
}

/* Expandable dividend info */
.entity-edit-page .section-row.dividend-info.expandable {
  flex-direction: column;
  align-items: stretch;
}

.entity-edit-page .section-row.dividend-info.expandable > .section-label,
.entity-edit-page .section-row.dividend-info.expandable > .section-value {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.entity-edit-page .section-row.dividend-info.expandable > .section-value {
  margin-top: 4px;
}

/* Compact dividend row - subtle green/teal, not yellow */
.entity-edit-page .section-row.dividendes-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  margin-top: 4px;
  border-top: 1px dashed #e5e7eb;
}

.entity-edit-page .section-row.dividendes-row.overridden .dividend-pct-input-inline,
.entity-edit-page .section-row.dividendes-row.overridden .dividend-date-input {
  border-color: #10b981;
  background: #ecfdf5;
}

.entity-edit-page .dividend-label-row {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #374151;
  font-size: 13px;
}

.entity-edit-page .dividend-label-row .icon {
  font-size: 12px;
}

.entity-edit-page .dividendes-label {
  font-weight: 500;
  color: #6b7280;
}

.entity-edit-page .dividend-pct-input-inline {
  width: 42px;
  padding: 2px 4px;
  border: 1px solid #d1d5db;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
  background: #f9fafb;
  color: #374151;
}

.entity-edit-page .dividend-pct-input-inline:focus {
  outline: none;
  border-color: #10b981;
  background: white;
}

.entity-edit-page .dividend-pct-suffix {
  font-size: 11px;
  color: #6b7280;
}

.entity-edit-page .dividend-value-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.entity-edit-page .dividend-amount {
  font-size: 13px;
  font-weight: 600;
  color: #059669;
}

.entity-edit-page .dividend-date-section {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #6b7280;
}

.entity-edit-page .dividend-date-arrow {
  color: #9ca3af;
}

.entity-edit-page .dividend-date-input {
  padding: 2px 4px;
  border: 1px solid #d1d5db;
  border-radius: 3px;
  font-size: 11px;
  background: #f9fafb;
  color: #374151;
  width: 105px;
}

.entity-edit-page .dividend-date-input:focus {
  outline: none;
  border-color: #10b981;
  background: white;
}

.entity-edit-page .dividend-date-default {
  font-size: 10px;
  color: #9ca3af;
  font-style: italic;
}

.entity-edit-page .dividend-date-section .tax-year {
  padding: 1px 5px;
  background: #059669;
  color: white;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
}

.entity-edit-page .dividend-detail-btn {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #d1d5db;
  background: #f9fafb;
  color: #6b7280;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  margin-left: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.entity-edit-page .dividend-detail-btn:hover {
  background: #059669;
  color: white;
  border-color: #059669;
}

/* Dividend detail modal */
.dividend-detail-modal {
  max-width: 450px;
}

.dividend-detail-modal .modal-body {
  padding: 16px 20px;
}

.dividend-detail-grid {
  margin-bottom: 16px;
}

.dividend-detail-grid .detail-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  border-radius: 4px;
}

.dividend-detail-grid .detail-row:nth-child(odd) {
  background: #f8fafc;
}

.dividend-detail-grid .detail-row.highlight {
  background: #fef3c7;
  font-weight: 600;
}

.dividend-detail-grid .detail-row.highlight-green {
  background: #d1fae5;
  font-weight: 600;
}

.dividend-detail-grid .detail-row.total {
  border-top: 1px solid #e5e7eb;
  font-weight: 600;
  margin-top: 4px;
  padding-top: 12px;
}

.dividend-detail-grid .detail-label {
  color: #374151;
}

.dividend-detail-grid .detail-value {
  font-weight: 600;
  color: #111827;
}

.dividend-detail-grid .detail-value.neg {
  color: #dc2626;
}

.dividend-detail-section {
  margin-bottom: 16px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 6px;
}

.dividend-detail-section h5 {
  margin: 0 0 8px 0;
  color: #1f2937;
  font-size: 13px;
}

.dividend-detail-section .section-hint {
  font-size: 12px;
  color: #6b7280;
  margin: 0 0 8px 0;
}

.dividend-detail-section .tax-year-info {
  font-size: 12px;
  color: #059669;
  margin: 0;
  font-weight: 500;
}

.dividend-detail-section.result {
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
}

.dividend-detail-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  background: #fef3c7;
  border-radius: 6px;
  font-size: 12px;
  color: #92400e;
}

.dividend-detail-note .note-icon {
  flex-shrink: 0;
}

/* Affectation Detail Modal - improved styling */
.affectation-detail-modal {
  min-width: 420px;
}

.affectation-detail-modal .modal-header h4 {
  font-size: 15px;
  color: #1F2937;
}

.affectation-detail-modal .modal-body {
  padding: 16px 20px;
}

.affectation-section {
  margin-bottom: 20px;
  padding: 14px 16px;
  background: linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%);
  border-radius: 8px;
  border: 1px solid #E2E8F0;
}

.affectation-section h5 {
  margin: 0 0 10px 0;
  font-size: 13px;
  color: #1E293B;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}

.affectation-section .section-hint {
  font-size: 11px;
  color: #64748B;
  margin: 0 0 10px 0;
  font-style: italic;
}

.affectation-detail-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.affectation-detail-grid .detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: white;
  border-radius: 6px;
  font-size: 12px;
}

.affectation-detail-grid .detail-row.indent {
  margin-left: 16px;
  background: #FAFAFA;
}

.affectation-detail-grid .detail-row.sub-hint {
  background: transparent;
  padding: 2px 12px;
}

.affectation-detail-grid .detail-label-small {
  font-size: 10px;
  color: #9CA3AF;
  font-style: italic;
}

.affectation-detail-grid .detail-row.total {
  background: linear-gradient(90deg, #E0E7FF 0%, #EEF2FF 100%);
  font-weight: 600;
  border: 1px solid #C7D2FE;
  margin-top: 4px;
}

.affectation-detail-grid .detail-row.highlight-green {
  background: linear-gradient(90deg, #D1FAE5 0%, #ECFDF5 100%);
  border: 1px solid #A7F3D0;
  font-weight: 600;
}

.affectation-detail-grid .detail-label {
  color: #374151;
}

.affectation-detail-grid .detail-value {
  font-weight: 600;
  color: #111827;
}

.affectation-detail-grid .detail-value.pos {
  color: #059669;
}

.affectation-detail-grid .detail-value.neg {
  color: #DC2626;
}

.affectation-note {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  background: linear-gradient(90deg, #FEF3C7 0%, #FFFBEB 100%);
  border: 1px solid #FDE68A;
  border-radius: 8px;
  font-size: 11px;
  color: #92400E;
  line-height: 1.5;
}

.affectation-note .note-icon {
  font-size: 14px;
  flex-shrink: 0;
}

.entity-edit-page .treasury-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  margin-bottom: 4px;
}

.entity-edit-page .treasury-row:hover {
  background: rgba(217, 119, 6, 0.1);
}

.entity-edit-page .treasury-label {
  font-size: 12px;
  color: #78350F;
  cursor: help;
}

.entity-edit-page .treasury-value {
  font-size: 13px;
  font-weight: 600;
  color: #78350F;
}

.entity-edit-page .treasury-value.neg {
  color: #DC2626;
}

.entity-edit-page .treasury-row.net-row {
  background: rgba(5, 150, 105, 0.1);
  border: 1px solid rgba(5, 150, 105, 0.3);
}

.entity-edit-page .treasury-row.net-row .treasury-value {
  color: #059669;
}

.entity-edit-page .treasury-breakdown {
  display: flex;
  gap: 16px;
  font-size: 10px;
  color: #92400E;
  padding: 2px 8px;
  margin-bottom: 6px;
}

.entity-edit-page .treasury-impact {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #FFFBEB;
  border: 1px solid #FCD34D;
  border-radius: 4px;
  margin-top: 8px;
}

.entity-edit-page .treasury-impact .impact-icon {
  font-size: 14px;
}

.entity-edit-page .treasury-impact .impact-text {
  font-size: 11px;
  color: #78350F;
  line-height: 1.3;
}

/* Fiscal params row */
.entity-edit-page .hypotheses-edit-form .fiscal-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.entity-edit-page .hypotheses-edit-form .fiscal-row label {
  font-size: 12px;
  color: #64748B;
}

.entity-edit-page .hypotheses-edit-form .fiscal-row input[type="number"] {
  width: 50px;
  padding: 5px 8px;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  font-size: 13px;
  text-align: right;
}

.entity-edit-page .hypotheses-edit-form .fiscal-row input[type="number"]:focus {
  outline: none;
  border-color: #F59E0B;
}

.entity-edit-page .hypotheses-edit-form .fiscal-row .separator {
  color: #CBD5E1;
  font-size: 12px;
}

.entity-edit-page .hypotheses-edit-form .small-input {
  width: 50px !important;
}

/* Dates row in hypothesis editor */
.entity-edit-page .hypotheses-edit-form .dates-row {
  flex-wrap: wrap;
}

.entity-edit-page .hypotheses-edit-form .dates-edit-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.entity-edit-page .hypotheses-edit-form .dates-edit-row label {
  font-size: 12px;
  color: #64748B;
  font-weight: 500;
}

.entity-edit-page .hypotheses-edit-form .dates-edit-row .date-input {
  padding: 6px 10px;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  font-size: 13px;
  background: white;
  cursor: pointer;
}

.entity-edit-page .hypotheses-edit-form .dates-edit-row .date-input:focus {
  outline: none;
  border-color: #F59E0B;
}

.entity-edit-page .hypotheses-edit-form .dates-edit-row .cloture-select {
  padding: 6px 10px;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  font-size: 12px;
  background: white;
  cursor: pointer;
  min-width: 120px;
}

.entity-edit-page .hypotheses-edit-form .dates-edit-row .cloture-select:focus {
  outline: none;
  border-color: #F59E0B;
}

.entity-edit-page .hypotheses-edit-form .dates-edit-row .first-exercice-select {
  padding: 6px 10px;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  font-size: 12px;
  background: white;
  cursor: pointer;
  min-width: 80px;
}

.entity-edit-page .hypotheses-edit-form .dates-edit-row .first-exercice-select:focus {
  outline: none;
  border-color: #F59E0B;
}

.entity-edit-page .hypotheses-edit-form .dates-edit-row .separator {
  color: #CBD5E1;
  font-size: 14px;
}

/* Date info in read-only summary */
.entity-edit-page .step2-summary .dates-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.entity-edit-page .step2-summary .dates-info .date-sep {
  color: #CBD5E1;
  font-size: 11px;
}

/* Exercice limit warning */
.entity-edit-page .exercice-limit-warning {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 14px;
  background: #FEF3C7;
  border: 1px solid #F59E0B;
  border-radius: 6px;
  margin-top: 12px;
  font-size: 12px;
  color: #92400E;
  line-height: 1.4;
}

.entity-edit-page .exercice-limit-warning .warning-icon {
  flex-shrink: 0;
  font-size: 14px;
}

/* ===================== SARL DIVIDEND WARNING ===================== */
/* Warning for SARL when dividends exceed 10% of capital (SSI charges) */

.entity-edit-page .sarl-dividend-warning {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 14px;
  background: #FEF3C7;
  border: 1px solid #F59E0B;
  border-radius: 6px;
  margin: 8px 16px;
  font-size: 12px;
  color: #92400E;
  line-height: 1.5;
}

.entity-edit-page .sarl-dividend-warning .warning-icon {
  flex-shrink: 0;
  font-size: 14px;
}

.entity-edit-page .sarl-dividend-warning .warning-text {
  flex: 1 1;
}

/* ===================== SHOW RELATION BUTTON ===================== */

.entity-edit-page .btn-show-relation {
  background: #3B82F6;
  color: white;
  border: none;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.entity-edit-page .btn-show-relation:hover {
  background: #2563EB;
}
`, "",{"version":3,"sources":["webpack://./src/components/Entity/EntityEditPage.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C,gEAAgE;;AAEhE,iEAAiE;AACjE,kFAAkF;;AAElF;EACE,eAAe;EACf,UAAU,GAAG,kDAAkD;EAC/D,WAAW,GAAG,gDAAgD;EAC9D,UAAU,IAAI,mCAAmC;EACjD,WAAW,GAAG,mCAAmC;EACjD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa,GAAG,8CAA8C;EAC9D,gBAAgB;EAChB,mBAAmB,GAAG,8BAA8B;EACpD,yBAAyB,GAAG,uBAAuB;EACnD,0CAA0C;AAC5C;;AAEA;EACE;IACE,SAAS;IACT,UAAU;IACV,UAAU;IACV,WAAW;EACb;AACF;;AAEA,gCAAgC;AAChC;EACE,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA,uDAAuD;;AAEvD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,oDAAoD;AACtD;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,qDAAqD;;AAErD;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;EAChD,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,4CAA4C;AAC5C;EACE,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;AACd;;AAEA,mEAAmE;AACnE;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;;;;;EAKE,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,4DAA4D;AAC5D;EACE,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,oCAAoC;EACpC,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,4DAA4D;EAC5D,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,4DAA4D;EAC5D,0BAA0B;EAC1B,oCAAoC,EAAE,iCAAiC;AACzE;;;;AAIA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,4DAA4D;EAC5D,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,4DAA4D;EAC5D,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,mFAAmF;;AAEnF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gEAAgE;;AAEhE;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,WAAW,2CAA2C,EAAE;EACxD,MAAM,6CAA6C,EAAE;AACvD;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,8DAA8D;AAC9D,2DAA2D;;AAE3D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,kCAA0B;UAA1B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iDAAiD;EACjD,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qDAAqD;AACvD;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,QAAQ;EACR,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2EAA2E;EAC3E,qHAAqH;EACrH,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,2EAA2E;EAC3E,qHAAqH;EACrH,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,qDAAqD;AACrD;;EAEE,6DAA6D;EAC7D,mFAAmF;AACrF;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mEAAmE;;AAEnE;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,kCAAkC;EAClC,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA,mEAAmE;;AAEnE;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,6DAA6D;AAC/D;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,oBAAoB,EAAE,qBAAqB;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,WAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,8BAA8B;AAChC;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,4DAA4D;EAC5D,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,4DAA4D;EAC5D,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,4DAA4D;EAC5D,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,sEAAsE;AACtE,wEAAwE;;AAExE;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA,qEAAqE;;AAErE;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* src/components/Entity/EntityEditPage.css */\n/* Same design pattern as PersonEditPage - single page edition */\n\n/* ===================== FULL PAGE LAYOUT ===================== */\n/* Covers only the lanes area - sidebar, tabs and scenario header remain visible */\n\n.entity-edit-page {\n  position: fixed;\n  top: 120px;  /* Below: tabs (~50px) + scenario header (~70px) */\n  left: 228px;  /* After sidebar (220px) + lanes padding (8px) */\n  right: 8px;   /* Same margin as lanes-container */\n  bottom: 8px;  /* Same margin as lanes-container */\n  display: flex;\n  flex-direction: column;\n  background: #F8FAFC;\n  z-index: 1100;  /* Above the App save button (z-index: 1000) */\n  overflow: hidden;\n  border-radius: 10px;  /* Match lanes border-radius */\n  border: 1px solid #BDC3C7;  /* Match lanes border */\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n@media (max-width: 768px) {\n  .entity-edit-page {\n    left: 8px;\n    right: 8px;\n    top: 120px;\n    bottom: 8px;\n  }\n}\n\n/* Standalone mode - full page */\n.entity-edit-page.standalone {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 0;\n  border: none;\n}\n\n/* ===================== TOPBAR ===================== */\n\n.entity-edit-page .edit-topbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n  color: white;\n  flex-shrink: 0;\n}\n\n.entity-edit-page .topbar-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.entity-edit-page .topbar-left h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.entity-edit-page .topbar-left .legal-badge {\n  background: rgba(255,255,255,0.2);\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.entity-edit-page .topbar-left .tax-badge {\n  background: rgba(255,255,255,0.15);\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n}\n\n.entity-edit-page .topbar-left .activity-badge {\n  font-size: 11px;\n  opacity: 0.85;\n}\n\n.entity-edit-page .standalone-badge {\n  background: rgba(255,255,255,0.2);\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.entity-edit-page .topbar-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.entity-edit-page .save-btn {\n  padding: 8px 20px;\n  background: rgba(255,255,255,0.2);\n  border: 1px solid rgba(255,255,255,0.4);\n  color: white;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 110px;\n}\n\n.entity-edit-page .save-btn:hover:not(:disabled) {\n  background: rgba(255,255,255,0.35);\n}\n\n.entity-edit-page .save-btn:disabled {\n  cursor: wait;\n  opacity: 0.7;\n}\n\n.entity-edit-page .save-btn.saving {\n  background: rgba(255,255,255,0.15);\n  animation: entitySavingPulse 1s ease-in-out infinite;\n}\n\n@keyframes entitySavingPulse {\n  0%, 100% { opacity: 0.7; }\n  50% { opacity: 1; }\n}\n\n.entity-edit-page .save-btn.success {\n  background: rgba(16, 185, 129, 0.7);\n  border-color: rgba(16, 185, 129, 0.9);\n}\n\n.entity-edit-page .close-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: white;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.entity-edit-page .close-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n/* ===================== BODY ===================== */\n\n.entity-edit-page .edit-body {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 16px;\n}\n\n/* Wrapper for wizard styles */\n.entity-edit-page .edit-body .wizard-add-entity {\n  position: static;\n  display: block;\n  height: auto;\n  width: 100%;\n  background: transparent;\n  overflow: visible;\n}\n\n/* Make exercice cards fit better */\n.entity-edit-page .exercice-card {\n  max-width: 100%;\n  min-width: 0;\n}\n\n.entity-edit-page .wizard-add-entity .exercices-compact-list {\n  display: grid !important;\n  grid-template-columns: repeat(3, 1fr) !important;\n  flex-direction: unset !important;\n  gap: 12px;\n  align-items: start;\n}\n\n/* Responsive: 2 columns on medium screens, 1 on small */\n@media (max-width: 1400px) {\n  .entity-edit-page .wizard-add-entity .exercices-compact-list {\n    grid-template-columns: repeat(2, 1fr) !important;\n  }\n}\n\n@media (max-width: 900px) {\n  .entity-edit-page .wizard-add-entity .exercices-compact-list {\n    grid-template-columns: 1fr !important;\n  }\n}\n\n/* Smaller exercice header for grid layout */\n.entity-edit-page .exercice-header {\n  padding: 6px 10px;\n  gap: 6px;\n}\n\n.entity-edit-page .exercice-header strong {\n  font-size: 11px;\n}\n\n/* Compact exercice body */\n.entity-edit-page .exercice-body {\n  padding: 6px;\n}\n\n/* Compact section rows - consistent height for ALL section types */\n.entity-edit-page .wizard-add-entity .section-row {\n  padding: 2px 8px !important;\n  min-height: 22px !important;\n  height: 22px !important;\n  margin-bottom: 1px !important;\n  align-items: baseline !important;\n}\n\n.entity-edit-page .wizard-add-entity .section-row.produits,\n.entity-edit-page .wizard-add-entity .section-row.charges,\n.entity-edit-page .wizard-add-entity .section-row.resultat-avant-is,\n.entity-edit-page .wizard-add-entity .section-row.is-row,\n.entity-edit-page .wizard-add-entity .section-row.resultat {\n  padding: 2px 8px !important;\n  min-height: 22px !important;\n  height: 22px !important;\n  margin-top: 2px !important;\n  margin-bottom: 1px !important;\n}\n\n/* Affectation section - single line like Produits/Charges */\n.entity-edit-page .wizard-add-entity .section-row.affectation {\n  background: #F8FAFC !important;\n  border-left: 3px solid #8B5CF6 !important;\n}\n\n.entity-edit-page .section-row.affectation .section-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.entity-edit-page .section-row.affectation .section-value.affectation-inputs {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.entity-edit-page .affectation-inputs .input-group {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  background: rgba(139, 92, 246, 0.08);\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n.entity-edit-page .affectation-inputs .input-label {\n  font-size: 9px;\n  color: #6B7280;\n  font-weight: 500;\n}\n\n.entity-edit-page .affectation-inputs .date-input {\n  width: 75px !important;\n  height: 16px !important;\n  font-size: 9px !important;\n  padding: 1px 2px !important;\n  border: 1px solid #D1D5DB !important;\n  border-radius: 3px !important;\n  background: white;\n}\n\n.entity-edit-page .affectation-inputs .pct-input {\n  width: 28px !important;\n  height: 16px !important;\n  font-size: 10px !important;\n  padding: 1px 3px !important;\n  border: 1px solid #D1D5DB !important;\n  border-radius: 3px !important;\n  text-align: center;\n  background: white;\n}\n\n/* Réserve légale row - styled as sub-row */\n.entity-edit-page .line-row.reserve-legale-row {\n  background: linear-gradient(90deg, #F3E8FF 0%, #FAF5FF 100%);\n  border-left-color: #A855F7;\n  padding: 1px 8px 1px 21px !important;\n}\n\n.entity-edit-page .plafond-badge {\n  font-size: 8px;\n  background: #A855F7;\n  color: white;\n  padding: 1px 4px;\n  border-radius: 3px;\n  margin-left: 4px;\n}\n\n/* Dividendes row - styled as sub-row */\n.entity-edit-page .line-row.dividendes-row {\n  background: linear-gradient(90deg, #FEF3C7 0%, #FFFBEB 100%);\n  border-left-color: #F59E0B;\n  padding: 1px 8px 1px 21px !important; /* Override WizardAddEntity.css */\n}\n\n\n\n.entity-edit-page .tax-year-badge {\n  font-size: 8px;\n  background: #F59E0B;\n  color: white;\n  padding: 1px 4px;\n  border-radius: 3px;\n  margin-left: 4px;\n}\n\n.entity-edit-page .line-row.dividendes-row .line-value,\n.entity-edit-page .line-row.report-row .line-value,\n.entity-edit-page .line-row.reserve-legale-row .line-value {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n}\n\n\n.entity-edit-page .line-value .amount {\n  font-weight: 600;\n}\n\n.entity-edit-page .line-value .amount.pos {\n  color: #059669;\n}\n\n.entity-edit-page .line-value .amount.neg {\n  color: #DC2626;\n}\n\n/* Report N-1 row - incoming from previous exercice */\n.entity-edit-page .line-row.report-n1-row {\n  background: linear-gradient(90deg, #FEE2E2 0%, #FEF2F2 100%);\n  border-left-color: #F87171;\n  font-style: italic;\n}\n\n/* Report à nouveau row - styled as sub-row */\n.entity-edit-page .line-row.report-row {\n  background: linear-gradient(90deg, #E0E7FF 0%, #EEF2FF 100%);\n  border-left-color: #6366F1;\n}\n\n.entity-edit-page .report-hint {\n  font-size: 8px;\n  color: #6366F1;\n  margin-left: 4px;\n}\n\n/* Exercice dates clipped by forecast period */\n.entity-edit-page .exercice-header .periode {\n  font-size: 10px;\n  color: #64748B;\n  margin-left: 6px;\n}\n\n.entity-edit-page .exercice-header .periode.clipped {\n  color: #B45309;\n  font-weight: 600;\n}\n\n.entity-edit-page .clip-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 8px;\n  padding: 3px 8px;\n  background: #F59E0B;\n  color: white;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: help;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 3px rgba(245, 158, 11, 0.3);\n}\n\n.entity-edit-page .clip-icon:hover {\n  background: #D97706;\n  transform: scale(1.05);\n}\n\n/* ===================== MODE SELECTOR (Simplifié/Détaillé) ===================== */\n\n.entity-edit-page .mode-selector {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-left: auto;\n}\n\n.entity-edit-page .mode-selector-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n}\n\n.entity-edit-page .mode-selector-cards {\n  display: flex;\n  gap: 6px;\n}\n\n.entity-edit-page .mode-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n  padding: 8px 14px;\n  border: 2px solid #E2E8F0;\n  border-radius: 8px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 80px;\n}\n\n.entity-edit-page .mode-card:hover {\n  border-color: #F59E0B;\n  background: #FFFBEB;\n}\n\n.entity-edit-page .mode-card.selected {\n  border-color: #F59E0B;\n  background: #FEF3C7;\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.25);\n}\n\n.entity-edit-page .mode-card-icon {\n  font-size: 16px;\n}\n\n.entity-edit-page .mode-card-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n}\n\n.entity-edit-page .mode-card.selected .mode-card-label {\n  color: #B45309;\n}\n\n/* ===================== CA DATES HEADER ===================== */\n\n.entity-edit-page .ca-dates-header {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  padding: 10px 14px;\n  background: white;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.06);\n}\n\n.entity-edit-page .ca-dates-header.needs-end-date {\n  border: 2px solid #F59E0B;\n  background: #FFFBEB;\n}\n\n.entity-edit-page .ca-dates-header .date-field {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.entity-edit-page .ca-dates-header .date-field label {\n  font-size: 10px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n}\n\n.entity-edit-page .ca-dates-header .date-field label .required {\n  color: #F59E0B;\n  font-weight: 700;\n}\n\n.entity-edit-page .ca-dates-header .date-sep {\n  font-size: 14px;\n  color: #94A3B8;\n  padding-bottom: 5px;\n}\n\n.entity-edit-page .source-date {\n  padding: 6px 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n.entity-edit-page .source-date:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.entity-edit-page .source-date.pulse {\n  animation: pulse-border 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse-border {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.4); }\n  50% { box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.2); }\n}\n\n.entity-edit-page .empty-sources.waiting {\n  background: #FFFBEB;\n  border: 1px dashed #F59E0B;\n  text-align: center;\n  padding: 20px;\n  border-radius: 8px;\n}\n\n.entity-edit-page .empty-sources .arrow-up {\n  font-size: 24px;\n  color: #F59E0B;\n  display: block;\n  margin-bottom: 8px;\n  animation: bounce 1s ease-in-out infinite;\n}\n\n@keyframes bounce {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-5px); }\n}\n\n.entity-edit-page .empty-sources p {\n  margin: 0;\n  color: #64748B;\n  font-size: 13px;\n}\n\n.entity-edit-page .empty-sources .empty-hint {\n  display: block;\n  margin-top: 6px;\n  font-size: 11px;\n  color: #94A3B8;\n}\n\n/* ===================== PORTAL MODALS ===================== */\n/* Styles for modals rendered via portal to document.body */\n\n.entity-edit-modal-portal .charges-var-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(15, 23, 42, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  z-index: 99999;\n  padding: 40px 20px;\n  overflow-y: auto;\n  animation: modalFadeIn 0.2s ease;\n}\n\n@keyframes modalFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.entity-edit-modal-portal .charges-var-modal {\n  background: white;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 600px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  animation: modalSlideIn 0.25s ease;\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  max-height: calc(100vh - 80px);\n}\n\n.entity-edit-modal-portal .charges-var-modal.wide {\n  max-width: 800px;\n}\n\n.entity-edit-modal-portal .charges-var-modal.extra-wide {\n  max-width: 980px;\n}\n\n@keyframes modalSlideIn {\n  from { opacity: 0; transform: translateY(-20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.entity-edit-modal-portal .modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n  color: white;\n  border-radius: 16px 16px 0 0;\n  flex-shrink: 0;\n}\n\n.entity-edit-modal-portal .modal-header h4 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.entity-edit-modal-portal .modal-header .pcg-badge {\n  background: rgba(255,255,255,0.2);\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.entity-edit-modal-portal .modal-header .close-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.entity-edit-modal-portal .modal-header .close-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.entity-edit-modal-portal .modal-body {\n  padding: 20px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.entity-edit-modal-portal .modal-hint {\n  font-size: 13px;\n  color: #64748B;\n  margin: 0 0 16px 0;\n  padding: 10px 14px;\n  background: #F8FAFC;\n  border-radius: 8px;\n  border-left: 3px solid #F59E0B;\n}\n\n.entity-edit-modal-portal .modal-hint .prorata-hint {\n  color: #D97706;\n  font-weight: 500;\n}\n\n.entity-edit-modal-portal .modal-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-top: 1px solid #E2E8F0;\n  background: #FAFBFC;\n  border-radius: 0 0 16px 16px;\n  flex-shrink: 0;\n}\n\n.entity-edit-modal-portal .footer-hint {\n  font-size: 11px;\n  color: #94A3B8;\n}\n\n.entity-edit-modal-portal .footer-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.entity-edit-modal-portal .btn-cancel {\n  padding: 8px 16px;\n  border: 1px solid #E2E8F0;\n  background: white;\n  border-radius: 8px;\n  font-size: 13px;\n  cursor: pointer;\n  color: #64748B;\n}\n\n.entity-edit-modal-portal .btn-cancel:hover {\n  background: #F8FAFC;\n}\n\n.entity-edit-modal-portal .btn-save {\n  padding: 8px 20px;\n  border: none;\n  background: linear-gradient(135deg, #F59E0B, #D97706);\n  color: white;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.entity-edit-modal-portal .btn-save:hover {\n  background: linear-gradient(135deg, #D97706, #B45309);\n}\n\n/* Charges summary table */\n.entity-edit-modal-portal .charges-summary-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 16px;\n}\n\n.entity-edit-modal-portal .charges-summary-table td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #E2E8F0;\n  font-size: 13px;\n}\n\n.entity-edit-modal-portal .charges-summary-table .neg {\n  color: #DC2626;\n  text-align: right;\n  font-weight: 600;\n}\n\n.entity-edit-modal-portal .charges-summary-table .total-row td {\n  background: #F8FAFC;\n  font-weight: 600;\n}\n\n/* Charges table base */\n.entity-edit-modal-portal .charges-table {\n  border: 1px solid #E2E8F0;\n  border-radius: 10px;\n  overflow: hidden;\n  margin-bottom: 16px;\n}\n\n.entity-edit-modal-portal .charges-table .table-header {\n  display: grid;\n  grid-template-columns: 28px 1fr 70px 100px;\n  gap: 8px;\n  padding: 10px 14px;\n  background: #F1F5F9;\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.entity-edit-modal-portal .charges-table .table-body {\n  background: white;\n}\n\n.entity-edit-modal-portal .charges-table .table-row {\n  display: grid;\n  grid-template-columns: 28px 1fr 70px 100px;\n  gap: 8px;\n  padding: 12px 14px;\n  border-top: 1px solid #F1F5F9;\n  align-items: center;\n}\n\n.entity-edit-modal-portal .charges-table .table-row:first-child {\n  border-top: none;\n}\n\n.entity-edit-modal-portal .charges-table .table-row:hover {\n  background: #FAFBFC;\n}\n\n.entity-edit-modal-portal .charges-table .table-row.enabled {\n  background: #FFFBEB;\n}\n\n.entity-edit-modal-portal .charges-table .col-check input {\n  width: 16px;\n  height: 16px;\n  accent-color: #F59E0B;\n  cursor: pointer;\n}\n\n.entity-edit-modal-portal .charges-table .col-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #334155;\n}\n\n.entity-edit-modal-portal .charges-table .col-label .icon {\n  font-size: 14px;\n}\n\n.entity-edit-modal-portal .charges-table .col-type select {\n  padding: 5px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 11px;\n  background: white;\n}\n\n.entity-edit-modal-portal .charges-table .col-amount input {\n  width: 80px;\n  padding: 6px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  text-align: right;\n}\n\n.entity-edit-modal-portal .charges-table .col-amount input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.entity-edit-modal-portal .charges-table .col-amount input:disabled {\n  background: #F8FAFC;\n  color: #94A3B8;\n}\n\n/* Simple grid for simplified mode */\n.entity-edit-modal-portal .simple-grid {\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 16px;\n}\n\n.entity-edit-modal-portal .simple-grid .grid-row {\n  display: grid;\n  grid-template-columns: 1fr 200px;\n  gap: 16px;\n  padding: 12px 16px;\n  align-items: center;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.entity-edit-modal-portal .simple-grid .grid-row:not(.header):hover {\n  background: #F8FAFC;\n}\n\n.entity-edit-modal-portal .simple-grid .grid-row.header {\n  background: #F8FAFC;\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  padding: 8px 16px;\n  cursor: default;\n}\n\n.entity-edit-modal-portal .simple-grid .grid-row.selected {\n  background: #FFFBEB;\n}\n\n.entity-edit-modal-portal .simple-grid .grid-row + .grid-row {\n  border-top: 1px solid #E2E8F0;\n}\n\n.entity-edit-modal-portal .simple-grid .col-type {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  color: #334155;\n}\n\n.entity-edit-modal-portal .simple-grid .col-type input[type=\"radio\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #F59E0B;\n}\n\n.entity-edit-modal-portal .simple-grid .col-value {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.entity-edit-modal-portal .simple-grid .col-value input {\n  width: 100px;\n  padding: 8px 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: right;\n}\n\n.entity-edit-modal-portal .simple-grid .col-value input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.entity-edit-modal-portal .simple-grid .col-value input:disabled {\n  background: #F8FAFC;\n  color: #94A3B8;\n}\n\n.entity-edit-modal-portal .simple-grid .col-value .unit {\n  font-size: 12px;\n  color: #64748B;\n  min-width: 35px;\n}\n\n/* Mode toggle row */\n.entity-edit-modal-portal .mode-toggle-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.entity-edit-modal-portal .mode-toggle-row .mode-label {\n  font-size: 12px;\n  color: #64748B;\n  font-weight: 500;\n}\n\n/* Impots table - grid layout */\n.entity-edit-modal-portal .impots-table {\n  border: 1px solid #E2E8F0;\n  border-radius: 10px;\n  overflow: hidden;\n  margin-bottom: 16px;\n}\n\n.entity-edit-modal-portal .impots-table .table-header {\n  display: grid;\n  grid-template-columns: 180px 1fr 140px 120px;\n  gap: 8px;\n  padding: 10px 14px;\n  background: #F1F5F9;\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.entity-edit-modal-portal .impots-table .table-body {\n  background: white;\n}\n\n.entity-edit-modal-portal .impots-table .impot-row {\n  display: grid;\n  grid-template-columns: 180px 1fr 140px 120px;\n  gap: 8px;\n  padding: 14px;\n  border-top: 1px solid #F1F5F9;\n  align-items: start;\n}\n\n.entity-edit-modal-portal .impots-table .impot-row:first-child {\n  border-top: none;\n}\n\n.entity-edit-modal-portal .impots-table .impot-row.disabled {\n  opacity: 0.5;\n  background: #FAFBFC;\n}\n\n.entity-edit-modal-portal .col-impot-label strong {\n  display: block;\n  font-size: 13px;\n  color: #1E293B;\n  margin-bottom: 2px;\n}\n\n.entity-edit-modal-portal .col-impot-label .impot-subtitle {\n  font-size: 10px;\n  color: #94A3B8;\n}\n\n.entity-edit-modal-portal .hypothesis-inputs {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.entity-edit-modal-portal .hypothesis-inputs .input-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.entity-edit-modal-portal .hypothesis-inputs .input-row label {\n  font-size: 11px;\n  color: #64748B;\n  min-width: 80px;\n}\n\n.entity-edit-modal-portal .input-with-suffix {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.entity-edit-modal-portal .input-with-suffix input {\n  width: 70px;\n  padding: 6px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 12px;\n  text-align: right;\n}\n\n.entity-edit-modal-portal .input-with-suffix input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.entity-edit-modal-portal .input-with-suffix span {\n  font-size: 11px;\n  color: #64748B;\n  min-width: 20px;\n}\n\n.entity-edit-modal-portal .mode-toggle {\n  display: flex;\n  gap: 2px;\n  padding: 2px;\n  background: #F1F5F9;\n  border-radius: 6px;\n}\n\n.entity-edit-modal-portal .mode-toggle.compact {\n  padding: 1px;\n}\n\n.entity-edit-modal-portal .mode-toggle button {\n  padding: 5px 10px;\n  border: none;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  background: transparent;\n  color: #64748B;\n  transition: all 0.15s;\n}\n\n.entity-edit-modal-portal .mode-toggle button.active {\n  background: white;\n  color: #1E293B;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.entity-edit-modal-portal .calcul-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.entity-edit-modal-portal .calcul-formula {\n  font-size: 10px;\n  color: #64748B;\n  font-family: monospace;\n}\n\n.entity-edit-modal-portal .calcul-formula.positive {\n  color: #16A34A;\n  font-weight: 600;\n}\n\n.entity-edit-modal-portal .calcul-note.warning {\n  color: #D97706;\n  font-weight: 500;\n}\n\n.entity-edit-modal-portal .editable-amount {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.entity-edit-modal-portal .editable-amount .amount-input {\n  width: 80px;\n  padding: 6px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  text-align: right;\n}\n\n.entity-edit-modal-portal .editable-amount .amount-input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.entity-edit-modal-portal .editable-amount .currency {\n  font-size: 12px;\n  color: #64748B;\n}\n\n.entity-edit-modal-portal .editable-amount .btn-reset {\n  background: #FEF3C7;\n  border: none;\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  color: #D97706;\n}\n\n.entity-edit-modal-portal .calc-indicator {\n  font-size: 10px;\n  color: #16A34A;\n  font-weight: 500;\n  margin-left: 4px;\n}\n\n.entity-edit-modal-portal .not-applicable {\n  font-size: 11px;\n  color: #94A3B8;\n  font-style: italic;\n}\n\n.entity-edit-modal-portal .info-line {\n  font-size: 10px;\n  color: #64748B;\n}\n\n.entity-edit-modal-portal .impot-rules-help {\n  background: #F0FDF4;\n  border: 1px solid #BBF7D0;\n  border-radius: 10px;\n  padding: 14px;\n  margin-bottom: 16px;\n}\n\n.entity-edit-modal-portal .impot-rules-help .rule-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 12px;\n  color: #166534;\n  margin-bottom: 8px;\n}\n\n.entity-edit-modal-portal .impot-rules-help .rule-item:last-child {\n  margin-bottom: 0;\n}\n\n.entity-edit-modal-portal .impot-rules-help .rule-icon {\n  font-size: 14px;\n}\n\n.entity-edit-modal-portal .modal-total {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 16px;\n  background: linear-gradient(135deg, #FEF3C7, #FDE68A);\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #92400E;\n}\n\n/* Tooltip */\n.entity-edit-modal-portal .help-icon {\n  font-size: 12px;\n  color: #94A3B8;\n  cursor: help;\n}\n\n/* Personnel table */\n.entity-edit-modal-portal .personnel-section {\n  margin-bottom: 20px;\n  padding: 16px;\n  background: #F8FAFC;\n  border-radius: 10px;\n  border: 1px solid #E2E8F0;\n}\n\n.entity-edit-modal-portal .personnel-section .section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.entity-edit-modal-portal .personnel-section h5 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1E293B;\n}\n\n.entity-edit-modal-portal .personnel-table .table-header {\n  display: grid;\n  grid-template-columns: 85px 130px 55px 95px 50px 100px 110px 95px 95px 30px;\n  /* Fonction | Personne | Statut | Brut/mois | Mois | Début rém. | Brut annuel | Charges pat. | Coût total | Actions */\n  gap: 8px;\n  padding: 10px 14px;\n  background: #E2E8F0;\n  border-radius: 6px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n  white-space: nowrap;\n}\n\n.entity-edit-modal-portal .personnel-table .personnel-row,\n.entity-edit-modal-portal .personnel-table .table-row {\n  display: grid;\n  grid-template-columns: 85px 130px 55px 95px 50px 100px 110px 95px 95px 30px;\n  /* Fonction | Personne | Statut | Brut/mois | Mois | Début rém. | Brut annuel | Charges pat. | Coût total | Actions */\n  gap: 8px;\n  padding: 12px 14px;\n  background: white;\n  border-radius: 6px;\n  margin-bottom: 6px;\n  align-items: center;\n  font-size: 12px;\n}\n\n/* Detailed mode (employees) - name column is wider */\n.entity-edit-modal-portal .personnel-table.detailed .table-header,\n.entity-edit-modal-portal .personnel-table.detailed .table-row {\n  grid-template-columns: 180px 120px 60px 60px 110px 100px 30px;\n  /* Poste/Nom | Brut/mois | Mois | Effectif | Charges pat. | Coût annuel | Actions */\n}\n\n.entity-edit-modal-portal .personnel-table .role-name {\n  font-weight: 600;\n  color: #1E293B;\n}\n\n.entity-edit-modal-portal .personnel-table .status-tag {\n  display: inline-block;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.entity-edit-modal-portal .personnel-table .status-tag.tns {\n  background: #DBEAFE;\n  color: #1D4ED8;\n}\n\n.entity-edit-modal-portal .personnel-table .status-tag.as {\n  background: #F3E8FF;\n  color: #7C3AED;\n}\n\n.entity-edit-modal-portal .personnel-table .months-input,\n.entity-edit-modal-portal .personnel-table .count-input {\n  width: 45px;\n  padding: 5px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  text-align: center;\n  font-size: 12px;\n}\n\n.entity-edit-modal-portal .personnel-table .charges-value {\n  font-size: 11px;\n  color: #DC2626;\n}\n\n.entity-edit-modal-portal .personnel-table .charges-rate {\n  font-size: 9px;\n  color: #94A3B8;\n  display: block;\n}\n\n.entity-edit-modal-portal .personnel-table .non-remunere {\n  font-size: 11px;\n  color: #94A3B8;\n  font-style: italic;\n}\n\n.entity-edit-modal-portal .personnel-table .col-personnel-annual {\n  text-align: right;\n}\n\n.entity-edit-modal-portal .personnel-table .annual-value {\n  font-weight: 600;\n  color: #1E293B;\n  font-size: 11px;\n}\n\n.entity-edit-modal-portal .personnel-table .prorata-badge {\n  display: inline-block;\n  background: #FEF3C7;\n  color: #92400E;\n  padding: 1px 4px;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 600;\n  margin-left: 4px;\n  cursor: help;\n}\n\n.entity-edit-modal-portal .personnel-table .tag-reduction {\n  background: #DCFCE7;\n  color: #166534;\n  padding: 1px 4px;\n  border-radius: 3px;\n  font-size: 8px;\n  font-weight: 600;\n  margin-left: 4px;\n}\n\n.entity-edit-modal-portal .btn-remove {\n  background: #FEE2E2;\n  border: none;\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n  cursor: pointer;\n  color: #DC2626;\n  font-size: 14px;\n}\n\n.entity-edit-modal-portal .btn-add-manager,\n.entity-edit-modal-portal .btn-add-employee {\n  padding: 8px 14px;\n  border: 1px dashed #D97706;\n  background: #FFFBEB;\n  border-radius: 6px;\n  color: #D97706;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  margin-top: 8px;\n}\n\n.entity-edit-modal-portal .no-data {\n  font-size: 12px;\n  color: #94A3B8;\n  font-style: italic;\n  text-align: center;\n  padding: 16px;\n}\n\n.entity-edit-modal-portal .toggle-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #64748B;\n  cursor: pointer;\n}\n\n.entity-edit-modal-portal .header-controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.entity-edit-modal-portal .modal-legend {\n  display: flex;\n  gap: 20px;\n  padding: 10px 14px;\n  background: #F8FAFC;\n  border-radius: 6px;\n  margin-bottom: 12px;\n  font-size: 11px;\n  color: #64748B;\n}\n\n.entity-edit-modal-portal .legend-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.entity-edit-modal-portal .legend-input {\n  width: 16px;\n  height: 16px;\n  border: 1px solid #E2E8F0;\n  border-radius: 3px;\n  background: white;\n}\n\n.entity-edit-modal-portal .legend-calc {\n  width: 16px;\n  height: 16px;\n  background: #F1F5F9;\n  border-radius: 3px;\n}\n\n/* Charge detail sections */\n.entity-edit-modal-portal .charge-detail-section {\n  margin-bottom: 16px;\n  padding: 14px;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n}\n\n.entity-edit-modal-portal .charge-detail-section h5 {\n  margin: 0 0 12px 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1E293B;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.entity-edit-modal-portal .charges-config-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.entity-edit-modal-portal .config-label {\n  font-size: 12px;\n  color: #64748B;\n  min-width: 150px;\n}\n\n.entity-edit-modal-portal .config-inputs {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.entity-edit-modal-portal .config-inputs select {\n  padding: 5px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 11px;\n}\n\n.entity-edit-modal-portal .config-inputs input {\n  width: 60px;\n  padding: 5px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  text-align: right;\n}\n\n.entity-edit-modal-portal .config-inputs .suffix {\n  font-size: 11px;\n  color: #64748B;\n}\n\n.entity-edit-modal-portal .config-result {\n  font-size: 12px;\n  font-weight: 600;\n  color: #1E293B;\n}\n\n.entity-edit-modal-portal .charge-total-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 14px;\n  background: #FEF3C7;\n  border-radius: 8px;\n  font-size: 13px;\n  margin-top: 16px;\n}\n\n.entity-edit-modal-portal .charge-total-row .neg {\n  color: #DC2626;\n}\n\n.entity-edit-modal-portal .info-text {\n  font-size: 12px;\n  color: #94A3B8;\n  font-style: italic;\n  padding: 10px;\n  text-align: center;\n}\n\n/* Tooltip portal styles */\n.tooltip-portal {\n  pointer-events: none;\n}\n\n.tooltip-content-portal {\n  background: #1E293B;\n  color: white;\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-size: 11px;\n  max-width: 200px;\n  white-space: normal;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.tooltip-content-portal::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n  border-top-color: #1E293B;\n}\n\n.tooltip-trigger {\n  cursor: help;\n}\n\n/* Empty row styles */\n.entity-edit-modal-portal .empty-row {\n  padding: 20px;\n  text-align: center;\n}\n\n.entity-edit-modal-portal .empty-message {\n  color: #94A3B8;\n  font-style: italic;\n  font-size: 12px;\n  grid-column: 1 / -1;\n}\n\n/* Add row styles */\n.entity-edit-modal-portal .add-row {\n  background: transparent !important;\n  padding: 8px 12px !important;\n}\n\n.entity-edit-modal-portal .add-cell {\n  grid-column: 1 / -1;\n}\n\n/* Input name for detailed employee profiles */\n.entity-edit-modal-portal .input-name {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.entity-edit-modal-portal .input-name:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n/* No data muted state */\n.entity-edit-modal-portal .no-data.muted {\n  color: #CBD5E1;\n}\n\n/* Modal add button style */\n.entity-edit-modal-portal .btn-add-manager.modal-add,\n.entity-edit-modal-portal .btn-add-employee.modal-add {\n  width: 100%;\n  margin-top: 12px;\n}\n\n/* CFE row specific styling */\n.entity-edit-modal-portal .cfe-row .impot-ca-info {\n  margin-top: 4px;\n}\n\n/* Calcul formula muted state */\n.entity-edit-modal-portal .calcul-formula.muted {\n  color: #CBD5E1;\n}\n\n/* Toggle row in hypothesis inputs */\n.entity-edit-modal-portal .toggle-row {\n  margin-bottom: 4px;\n}\n\n/* Input with suffix - ensure proper sizing */\n.entity-edit-modal-portal .input-with-suffix {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.entity-edit-modal-portal .input-with-suffix input {\n  width: 70px;\n  padding: 6px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 12px;\n  text-align: right;\n}\n\n.entity-edit-modal-portal .input-with-suffix input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.entity-edit-modal-portal .input-with-suffix span {\n  font-size: 11px;\n  color: #64748B;\n  min-width: 15px;\n}\n\n/* Personnel table column widths */\n.entity-edit-modal-portal .col-personnel-role {\n  min-width: 70px;\n}\n\n.entity-edit-modal-portal .col-personnel-person {\n  min-width: 130px;\n}\n\n.entity-edit-modal-portal .col-personnel-person .person-select {\n  width: 100%;\n  padding: 4px 6px;\n  font-size: 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.entity-edit-modal-portal .col-personnel-person .person-select:focus {\n  border-color: #3B82F6;\n  outline: none;\n}\n\n.entity-edit-modal-portal .col-personnel-status {\n  text-align: center;\n}\n\n.entity-edit-modal-portal .col-personnel-brut {\n  min-width: 90px;\n}\n\n.entity-edit-modal-portal .col-personnel-months {\n  text-align: center;\n}\n\n.entity-edit-modal-portal .col-personnel-salary-start {\n  text-align: center;\n}\n\n.entity-edit-modal-portal .col-personnel-salary-start input {\n  width: 100%;\n  max-width: 82px;\n  padding: 4px 3px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 10px;\n  text-align: center;\n  background: white;\n}\n\n.entity-edit-modal-portal .col-personnel-salary-start input:focus {\n  outline: none;\n  border-color: #F59E0B;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.1);\n}\n\n.entity-edit-modal-portal .col-personnel-salary-start input.locked,\n.entity-edit-modal-portal .col-personnel-salary-start input:disabled {\n  background: #F1F5F9;\n  color: #64748B;\n  cursor: not-allowed;\n  border-color: #CBD5E1;\n}\n\n.entity-edit-modal-portal .col-personnel-count {\n  text-align: center;\n}\n\n.entity-edit-modal-portal .col-personnel-charges {\n  text-align: right;\n}\n\n.entity-edit-modal-portal .col-personnel-cout {\n  text-align: right;\n  font-weight: 600;\n}\n\n.entity-edit-modal-portal .col-personnel-actions {\n  text-align: center;\n}\n\n.entity-edit-modal-portal .col-personnel-name {\n  min-width: 120px;\n}\n\n/* ==================== ADD PRODUCTS BUTTONS ==================== */\n\n.entity-edit-page .add-row.products-add {\n  display: flex;\n  gap: 8px;\n  padding: 6px 12px;\n  background: #F8FAFC;\n  border-radius: 4px;\n  margin: 4px 0;\n}\n\n.entity-edit-page .add-row.products-add button {\n  padding: 4px 10px;\n  font-size: 11px;\n  background: white;\n  border: 1px dashed #CBD5E1;\n  border-radius: 4px;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.entity-edit-page .add-row.products-add button:hover {\n  border-color: #F59E0B;\n  color: #F59E0B;\n  background: #FFF9E6;\n}\n\n/* ============================================\n   EXERCICE ROWS - NEW DESIGN SYSTEM\n   ============================================ */\n\n/* Base section row */\n.entity-edit-page .section-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px 8px;\n  min-height: 28px;\n  border-radius: 4px;\n  margin-bottom: 2px;\n}\n\n.entity-edit-page .section-label {\n  display: flex;\n  align-items: baseline;\n  gap: 5px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #1E293B;\n}\n\n.entity-edit-page .section-label .icon {\n  width: 16px;\n  text-align: center;\n  font-weight: 700;\n  font-size: 14px;\n  color: #6B7280;\n  flex-shrink: 0;\n}\n\n.entity-edit-page .section-label .pcg-num {\n  display: inline-block;\n  width: 28px;\n  text-align: right;\n  font-family: 'SF Mono', Monaco, Consolas, monospace;\n  font-size: 10px;\n  font-weight: 600;\n  color: #6B7280;\n  flex-shrink: 0;\n  margin-right: 6px;\n}\n\n.entity-edit-page .wizard-add-entity .section-value {\n  font-size: 12px;\n  font-weight: 700;\n  color: #1E293B;\n  text-align: right;\n}\n\n.entity-edit-page .section-value.neg {\n  color: #DC2626;\n}\n\n/* PRODUITS - Vert pâle (entrées) */\n.entity-edit-page .section-row.produits {\n  background: #ECFDF5;\n  border: 1px solid #A7F3D0;\n}\n\n.entity-edit-page .section-row.produits .section-label {\n  color: #065F46;\n}\n\n.entity-edit-page .section-row.produits .section-value {\n  color: #059669;\n}\n\n/* CHARGES - Rose pâle (sorties) */\n.entity-edit-page .section-row.charges {\n  background: #FEF2F2;\n  border: 1px solid #FECACA;\n  margin-top: 8px;\n}\n\n.entity-edit-page .section-row.charges .section-label {\n  color: #991B1B;\n}\n\n.entity-edit-page .section-row.charges .section-value {\n  color: #DC2626;\n}\n\n.entity-edit-page .section-row.charges.clickable {\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.entity-edit-page .section-row.charges.clickable:hover {\n  background: #FEE2E2;\n  border-color: #F87171;\n}\n\n.entity-edit-page .section-row.charges .expand-hint {\n  font-size: 10px;\n  font-weight: 400;\n  color: #9CA3AF;\n  margin-left: 8px;\n}\n\n/* RÉSULTAT AVANT IS - Gris neutre */\n.entity-edit-page .section-row.resultat-avant-is {\n  background: #F1F5F9;\n  border: 1px solid #E2E8F0;\n  margin-top: 8px;\n}\n\n/* IS - Ambre pâle (taxe) */\n.entity-edit-page .section-row.is-row {\n  background: #FEF9C3;\n  border: 1px solid #FDE047;\n}\n\n.entity-edit-page .section-row.is-row .is-rate {\n  font-size: 10px;\n  font-weight: 400;\n  color: #A16207;\n  margin-left: 4px;\n}\n\n.entity-edit-page .section-row.is-row .section-value {\n  color: #A16207;\n}\n\n/* RÉSULTAT NET - Fort contraste */\n.entity-edit-page .section-row.resultat {\n  margin-top: 8px;\n  border-width: 2px;\n}\n\n.entity-edit-page .section-row.resultat.pos {\n  background: #D1FAE5;\n  border: 2px solid #059669;\n}\n\n.entity-edit-page .section-row.resultat.pos .section-value {\n  color: #059669;\n}\n\n.entity-edit-page .section-row.resultat.neg {\n  background: #FEE2E2;\n  border: 2px solid #DC2626;\n}\n\n.entity-edit-page .section-row.resultat.neg .section-value {\n  color: #DC2626;\n}\n\n/* ============================================\n   LINE ROWS - Sous-lignes détail\n   ============================================ */\n\n.entity-edit-page .line-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1px 8px 1px 21px;\n  min-height: 20px;\n  height: 20px;\n  background: #FAFAFA;\n  border-left: 3px solid transparent;\n  margin-left: 10px;\n  margin-bottom: 1px;\n  border-radius: 3px;\n}\n\n.entity-edit-page .line-row.ca {\n  border-left-color: #10B981;\n  background: #F0FDF4;\n}\n\n/* Make CA inputs blend with line-row style */\n.entity-edit-page .line-row.ca .label-input {\n  background: transparent !important;\n  border: none !important;\n  font-size: 10px !important;\n  padding: 0 !important;\n  color: #374151 !important;\n}\n\n.entity-edit-page .line-row.ca .label-input:focus {\n  outline: none !important;\n  background: rgba(255,255,255,0.5) !important;\n}\n\n.entity-edit-page .line-row.ca .line-input input {\n  background: rgba(255,255,255,0.6) !important;\n  border: 1px solid #A7F3D0 !important;\n  font-size: 10px !important;\n  padding: 1px 4px !important;\n  width: 65px !important;\n  height: 16px !important;\n  border-radius: 3px !important;\n}\n\n.entity-edit-page .line-row.charge-line {\n  border-left-color: #F87171;\n  background: #FEF2F2;\n}\n\n.entity-edit-page .wizard-add-entity .line-label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 10px;\n  color: #374151;\n}\n\n.entity-edit-page .wizard-add-entity .line-label .pcg-num {\n  display: inline-flex;\n  justify-content: flex-start;\n  width: 36px !important;\n  min-width: 36px !important;\n  text-align: left !important;\n  font-family: 'SF Mono', Monaco, Consolas, monospace;\n  font-size: 10px;\n  font-weight: 600;\n  color: #6B7280;\n  flex-shrink: 0;\n  margin-right: 6px;\n}\n\n.entity-edit-page .line-input {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.entity-edit-page .line-input input {\n  width: 80px;\n  padding: 4px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: right;\n  background: #F9FAFB;\n}\n\n.entity-edit-page .line-input input:focus {\n  outline: none;\n  border-color: #3B82F6;\n  background: white;\n}\n\n.entity-edit-page .line-input span {\n  font-size: 11px;\n  color: #9CA3AF;\n}\n\n.entity-edit-page .line-value-with-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.entity-edit-page .line-value-with-btn span {\n  font-size: 12px;\n  font-weight: 600;\n  min-width: 80px;\n  text-align: right;\n}\n\n.entity-edit-page .line-value-with-btn span.neg {\n  color: #DC2626;\n}\n\n.entity-edit-page .mini-btn {\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  border: 1px solid #E2E8F0;\n  background: #F9FAFB;\n  color: #64748B;\n  font-size: 11px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.entity-edit-page .mini-btn:hover {\n  background: #E2E8F0;\n  color: #374151;\n}\n\n.entity-edit-page .mini-btn.info:hover {\n  background: #DBEAFE;\n  border-color: #3B82F6;\n  color: #3B82F6;\n}\n\n/* Mini tags */\n.entity-edit-page .mini-tag {\n  padding: 1px 4px;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 600;\n}\n\n.entity-edit-page .mini-tag.exo {\n  background: #D1FAE5;\n  color: #059669;\n}\n\n.entity-edit-page .mini-tag.reduc {\n  background: #FEF3C7;\n  color: #D97706;\n}\n\n.entity-edit-page .mini-tag.cvae {\n  background: #DBEAFE;\n  color: #2563EB;\n}\n\n/* Add row buttons */\n.entity-edit-page .add-row {\n  display: flex;\n  gap: 6px;\n  padding: 4px 12px 4px 24px;\n}\n\n.entity-edit-page .add-row button {\n  padding: 3px 8px;\n  font-size: 10px;\n  border: 1px dashed #D1D5DB;\n  background: transparent;\n  border-radius: 4px;\n  color: #6B7280;\n  cursor: pointer;\n}\n\n.entity-edit-page .add-row button:hover {\n  border-color: #3B82F6;\n  color: #3B82F6;\n  background: #EFF6FF;\n}\n\n/* CA Secondary row styling */\n.entity-edit-page .line-row.ca.secondary {\n  background: #F0FDF4;\n}\n\n.entity-edit-page .line-row.ca.secondary .line-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.entity-edit-page .line-row.ca.secondary .label-input {\n  flex: 1;\n  min-width: 80px;\n  max-width: 150px;\n}\n\n/* Clickable personnel line */\n.entity-edit-page .line-row.clickable-line {\n  cursor: pointer;\n  transition: background-color 0.2s;\n  border-radius: 4px;\n}\n\n.entity-edit-page .line-row.clickable-line:hover {\n  background-color: rgba(59, 130, 246, 0.08);\n}\n\n.entity-edit-page .linked-indicator {\n  margin-left: 8px;\n  display: inline-flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.entity-edit-page .linked-badge {\n  font-size: 10px;\n  padding: 2px 6px;\n  background: #DCFCE7;\n  color: #166534;\n  border-radius: 10px;\n  white-space: nowrap;\n}\n\n.entity-edit-page .unlinked-badge {\n  font-size: 10px;\n  padding: 2px 6px;\n  background: #FEF3C7;\n  color: #92400E;\n  border-radius: 10px;\n  white-space: nowrap;\n}\n\n/* Clickable table row in modal */\n.entity-edit-page tr.clickable-row {\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.entity-edit-page tr.clickable-row:hover {\n  background-color: rgba(59, 130, 246, 0.1);\n}\n\n.entity-edit-page .linked-indicator-inline {\n  margin-left: 8px;\n  display: inline-flex;\n  gap: 4px;\n}\n\n.entity-edit-page .linked-badge-sm,\n.entity-edit-page .unlinked-badge-sm {\n  font-size: 9px;\n  padding: 1px 5px;\n  border-radius: 8px;\n}\n\n.entity-edit-page .linked-badge-sm {\n  background: #DCFCE7;\n  color: #166534;\n}\n\n.entity-edit-page .unlinked-badge-sm {\n  background: #FEF3C7;\n  color: #92400E;\n}\n\n/* Mini remove button */\n.entity-edit-page .mini-btn.remove {\n  background: transparent;\n  border: none;\n  color: #EF4444;\n  cursor: pointer;\n  padding: 2px 6px;\n  font-size: 14px;\n  opacity: 0.6;\n  transition: opacity 0.2s;\n}\n\n.entity-edit-page .mini-btn.remove:hover {\n  opacity: 1;\n}\n\n/* ===================== HYPOTHESIS EDITING ===================== */\n\n.entity-edit-page .hypotheses-section-title {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 6px;\n}\n\n.entity-edit-page .step2-summary {\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.entity-edit-page .step2-summary:not(.editing):hover {\n  background: #FFF9E6;\n  border-color: #F59E0B;\n}\n\n.entity-edit-page .step2-summary.editing {\n  cursor: default;\n  border-radius: 8px;\n  border: 2px solid #F59E0B;\n  padding: 16px;\n  padding-right: 40px;\n  background: white;\n}\n\n.entity-edit-page .step2-summary .summary-header {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n.entity-edit-page .step2-summary .summary-header.editing-header {\n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.entity-edit-page .step2-summary .summary-header .summary-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.entity-edit-page .step2-summary .summary-header .summary-label-center {\n  font-size: 12px;\n  font-weight: 700;\n  color: #1E293B;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Action buttons container for hypothesis section - top right */\n.entity-edit-page .step2-summary .hyp-action-buttons {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  z-index: 10;\n}\n\n/* Single action button for hypothesis section - top right */\n.entity-edit-page .step2-summary .hyp-action-btn {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 12px;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.entity-edit-page .step2-summary > .hyp-action-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 10;\n}\n\n.entity-edit-page .step2-summary .hyp-action-btn.close {\n  padding: 4px 8px;\n  background: #E2E8F0;\n  color: #64748B;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1;\n}\n\n.entity-edit-page .step2-summary .hyp-action-btn.close:hover {\n  background: #CBD5E1;\n  color: #475569;\n}\n\n.entity-edit-page .step2-summary .hyp-action-btn.modifier {\n  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n  color: white;\n  box-shadow: 0 2px 4px rgba(245, 158, 11, 0.3);\n}\n\n.entity-edit-page .step2-summary .hyp-action-btn.modifier:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(245, 158, 11, 0.4);\n  background: linear-gradient(135deg, #FBBF24 0%, #F59E0B 100%);\n}\n\n.entity-edit-page .step2-summary .hyp-action-btn.appliquer {\n  background: linear-gradient(135deg, #10B981 0%, #059669 100%);\n  color: white;\n  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.3);\n}\n\n.entity-edit-page .step2-summary .hyp-action-btn.appliquer:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(16, 185, 129, 0.4);\n  background: linear-gradient(135deg, #34D399 0%, #10B981 100%);\n}\n\n.entity-edit-page .step2-summary .hyp-action-btn .btn-icon {\n  font-size: 14px;\n}\n\n.entity-edit-page .step2-summary .hyp-action-btn .btn-text {\n  font-size: 12px;\n}\n\n/* Compact summary content - single line */\n.entity-edit-page .step2-summary .summary-content-compact {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 12px;\n  padding-right: 100px; /* Space for button */\n}\n\n.entity-edit-page .step2-summary .summary-content-compact .summary-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #475569;\n}\n\n.entity-edit-page .step2-summary .summary-content-compact .summary-item strong {\n  color: #1E293B;\n}\n\n.entity-edit-page .step2-summary .summary-content-compact .summary-item em {\n  color: #64748B;\n  font-style: normal;\n}\n\n.entity-edit-page .step2-summary .summary-content-compact .status-badge {\n  font-size: 9px;\n  padding: 2px 5px;\n  border-radius: 3px;\n  font-weight: 600;\n}\n\n.entity-edit-page .step2-summary .summary-content-compact .status-badge.tns {\n  background: #DBEAFE;\n  color: #1D4ED8;\n}\n\n.entity-edit-page .step2-summary .summary-content-compact .status-badge.as {\n  background: #F3E8FF;\n  color: #7C3AED;\n}\n\n.entity-edit-page .step2-summary .summary-content-compact .summary-tag {\n  font-size: 9px;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-weight: 600;\n  background: #D1FAE5;\n  color: #065F46;\n}\n\n.entity-edit-page .step2-summary .summary-content-compact .summary-tag.jei {\n  background: #FEF3C7;\n  color: #92400E;\n}\n\n.entity-edit-page .step2-summary .summary-content-compact .summary-tag.tva {\n  background: #E0E7FF;\n  color: #3730A3;\n}\n\n/* Hypothesis edit form - 2 rows layout */\n.entity-edit-page .hypotheses-edit-form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #E2E8F0;\n}\n\n.entity-edit-page .hypotheses-edit-form .hyp-row {\n  display: flex;\n  gap: 12px;\n}\n\n.entity-edit-page .hypotheses-edit-form .edit-section {\n  background: #F8FAFC;\n  padding: 10px 14px;\n  border-radius: 6px;\n  border: 1px solid #E2E8F0;\n  flex: 1;\n}\n\n.entity-edit-page .hypotheses-edit-form .edit-section h4 {\n  margin: 0 0 8px 0;\n  font-size: 10px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Dirigeants section */\n.entity-edit-page .hypotheses-edit-form .dirigeants-section {\n  flex: 1.5;\n}\n\n.entity-edit-page .hypotheses-edit-form .dirigeants-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.entity-edit-page .hypotheses-edit-form .manager-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 10px;\n  background: white;\n  border-radius: 4px;\n  border: 1px solid #E2E8F0;\n}\n\n.entity-edit-page .hypotheses-edit-form .manager-row .manager-label {\n  font-weight: 600;\n  font-size: 12px;\n  color: #334155;\n  min-width: 75px;\n}\n\n.entity-edit-page .hypotheses-edit-form .manager-row input {\n  width: 70px;\n  padding: 5px 8px;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  font-size: 13px;\n  text-align: right;\n}\n\n.entity-edit-page .hypotheses-edit-form .manager-row input.small-input {\n  width: 50px;\n}\n\n.entity-edit-page .hypotheses-edit-form .manager-row input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.entity-edit-page .hypotheses-edit-form .manager-row .unit {\n  font-size: 11px;\n  color: #64748B;\n  min-width: 40px;\n}\n\n.entity-edit-page .hypotheses-edit-form .manager-row .status-badge {\n  font-size: 10px;\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-weight: 600;\n}\n\n.entity-edit-page .hypotheses-edit-form .manager-row .status-badge.tns {\n  background: #DBEAFE;\n  color: #1D4ED8;\n}\n\n.entity-edit-page .hypotheses-edit-form .manager-row .status-badge.as {\n  background: #F3E8FF;\n  color: #7C3AED;\n}\n\n.entity-edit-page .hypotheses-edit-form .add-btn {\n  background: transparent;\n  border: 1px dashed #CBD5E1;\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 11px;\n  color: #64748B;\n  cursor: pointer;\n  margin-top: 6px;\n}\n\n.entity-edit-page .hypotheses-edit-form .add-btn:hover {\n  border-color: #F59E0B;\n  color: #F59E0B;\n}\n\n/* Employés section */\n.entity-edit-page .hypotheses-edit-form .employes-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.entity-edit-page .hypotheses-edit-form .employes-row label {\n  font-size: 12px;\n  color: #64748B;\n}\n\n.entity-edit-page .hypotheses-edit-form .employes-row .toggle-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.entity-edit-page .hypotheses-edit-form .employes-row input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n  accent-color: #F59E0B;\n}\n\n.entity-edit-page .hypotheses-edit-form .employes-row input[type=\"number\"] {\n  width: 70px;\n  padding: 5px 8px;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  font-size: 13px;\n  text-align: right;\n}\n\n.entity-edit-page .hypotheses-edit-form .employes-row input[type=\"number\"].small-input {\n  width: 50px;\n}\n\n.entity-edit-page .hypotheses-edit-form .employes-row input[type=\"number\"]:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.entity-edit-page .hypotheses-edit-form .employes-row .separator {\n  color: #CBD5E1;\n}\n\n.entity-edit-page .hypotheses-edit-form .employes-row .unit {\n  font-size: 11px;\n  color: #64748B;\n}\n\n/* Charges section */\n.entity-edit-page .hypotheses-edit-form .charges-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.entity-edit-page .hypotheses-edit-form .charges-mode-toggle {\n  display: inline-flex;\n}\n\n.entity-edit-page .hypotheses-edit-form .charges-mode-toggle button {\n  padding: 5px 10px;\n  border: 1px solid #CBD5E1;\n  background: white;\n  font-size: 11px;\n  cursor: pointer;\n}\n\n.entity-edit-page .hypotheses-edit-form .charges-mode-toggle button:first-child {\n  border-radius: 4px 0 0 4px;\n  border-right: none;\n}\n\n.entity-edit-page .hypotheses-edit-form .charges-mode-toggle button:last-child {\n  border-radius: 0 4px 4px 0;\n}\n\n.entity-edit-page .hypotheses-edit-form .charges-mode-toggle button.active {\n  background: #F59E0B;\n  border-color: #F59E0B;\n  color: white;\n}\n\n.entity-edit-page .hypotheses-edit-form .charges-row input {\n  width: 80px;\n  padding: 5px 8px;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  font-size: 13px;\n  text-align: right;\n}\n\n.entity-edit-page .hypotheses-edit-form .charges-row input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.entity-edit-page .hypotheses-edit-form .charges-row .unit {\n  font-size: 11px;\n  color: #64748B;\n}\n\n/* Options section */\n.entity-edit-page .hypotheses-edit-form .options-row {\n  display: flex;\n  gap: 16px;\n}\n\n.entity-edit-page .hypotheses-edit-form .option-toggle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.entity-edit-page .hypotheses-edit-form .option-toggle input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n  accent-color: #F59E0B;\n}\n\n.entity-edit-page .hypotheses-edit-form .option-hint {\n  font-size: 10px;\n  color: #94A3B8;\n  font-weight: 400;\n}\n\n/* TVA select */\n.entity-edit-page .hypotheses-edit-form .tva-row {\n  display: flex;\n  align-items: center;\n}\n\n.entity-edit-page .hypotheses-edit-form .tva-select {\n  padding: 6px 10px;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  font-size: 12px;\n  background: white;\n  cursor: pointer;\n  min-width: 180px;\n}\n\n.entity-edit-page .hypotheses-edit-form .tva-select:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n/* Dividend row */\n.entity-edit-page .hypotheses-edit-form .dividend-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.entity-edit-page .hypotheses-edit-form .dividend-row label {\n  font-size: 12px;\n  color: #64748B;\n}\n\n.entity-edit-page .hypotheses-edit-form .dividend-row input {\n  width: 60px;\n  padding: 5px 8px;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  font-size: 13px;\n  text-align: right;\n}\n\n.entity-edit-page .hypotheses-edit-form .dividend-row input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n/* Capital row */\n.entity-edit-page .hypotheses-edit-form .capital-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.entity-edit-page .hypotheses-edit-form .capital-row input {\n  width: 100px;\n  padding: 5px 8px;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  font-size: 13px;\n  text-align: right;\n}\n\n.entity-edit-page .hypotheses-edit-form .capital-row input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.entity-edit-page .hypotheses-edit-form .medium-input {\n  width: 100px !important;\n}\n\n/* SARL dividend warning */\n.entity-edit-page .hypotheses-edit-form .sarl-dividend-warning {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  margin-top: 8px;\n  padding: 8px 10px;\n  background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%);\n  border: 1px solid #F59E0B;\n  border-radius: 6px;\n  font-size: 11px;\n  line-height: 1.4;\n}\n\n.entity-edit-page .hypotheses-edit-form .sarl-dividend-warning .warning-icon {\n  flex-shrink: 0;\n  font-size: 14px;\n}\n\n.entity-edit-page .hypotheses-edit-form .sarl-dividend-warning .warning-text {\n  color: #92400E;\n}\n\n.entity-edit-page .hypotheses-edit-form .sarl-dividend-warning .warning-text strong {\n  color: #78350F;\n}\n\n/* Dividend info in exercice card */\n.entity-edit-page .section-row.dividend-info {\n  background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%);\n  border-radius: 6px;\n  padding: 8px 12px;\n  margin-top: 8px;\n  border: 1px solid #F59E0B40;\n}\n\n.entity-edit-page .section-row.dividend-info .section-label {\n  color: #92400E;\n}\n\n.entity-edit-page .section-row.dividend-info .section-label .icon {\n  font-size: 14px;\n}\n\n.entity-edit-page .section-row.dividend-info .section-value {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  color: #92400E;\n  font-weight: 600;\n}\n\n.entity-edit-page .section-row.dividend-info .dividend-timing {\n  font-size: 11px;\n  font-weight: 400;\n  color: #B45309;\n}\n\n.entity-edit-page .section-row.dividend-info .dividend-timing .tax-year {\n  margin-left: 4px;\n  padding: 1px 6px;\n  background: #F59E0B;\n  color: white;\n  border-radius: 3px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n/* Expandable dividend info */\n.entity-edit-page .section-row.dividend-info.expandable {\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.entity-edit-page .section-row.dividend-info.expandable > .section-label,\n.entity-edit-page .section-row.dividend-info.expandable > .section-value {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.entity-edit-page .section-row.dividend-info.expandable > .section-value {\n  margin-top: 4px;\n}\n\n/* Compact dividend row - subtle green/teal, not yellow */\n.entity-edit-page .section-row.dividendes-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 0;\n  margin-top: 4px;\n  border-top: 1px dashed #e5e7eb;\n}\n\n.entity-edit-page .section-row.dividendes-row.overridden .dividend-pct-input-inline,\n.entity-edit-page .section-row.dividendes-row.overridden .dividend-date-input {\n  border-color: #10b981;\n  background: #ecfdf5;\n}\n\n.entity-edit-page .dividend-label-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #374151;\n  font-size: 13px;\n}\n\n.entity-edit-page .dividend-label-row .icon {\n  font-size: 12px;\n}\n\n.entity-edit-page .dividendes-label {\n  font-weight: 500;\n  color: #6b7280;\n}\n\n.entity-edit-page .dividend-pct-input-inline {\n  width: 42px;\n  padding: 2px 4px;\n  border: 1px solid #d1d5db;\n  border-radius: 3px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: right;\n  background: #f9fafb;\n  color: #374151;\n}\n\n.entity-edit-page .dividend-pct-input-inline:focus {\n  outline: none;\n  border-color: #10b981;\n  background: white;\n}\n\n.entity-edit-page .dividend-pct-suffix {\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.entity-edit-page .dividend-value-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.entity-edit-page .dividend-amount {\n  font-size: 13px;\n  font-weight: 600;\n  color: #059669;\n}\n\n.entity-edit-page .dividend-date-section {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.entity-edit-page .dividend-date-arrow {\n  color: #9ca3af;\n}\n\n.entity-edit-page .dividend-date-input {\n  padding: 2px 4px;\n  border: 1px solid #d1d5db;\n  border-radius: 3px;\n  font-size: 11px;\n  background: #f9fafb;\n  color: #374151;\n  width: 105px;\n}\n\n.entity-edit-page .dividend-date-input:focus {\n  outline: none;\n  border-color: #10b981;\n  background: white;\n}\n\n.entity-edit-page .dividend-date-default {\n  font-size: 10px;\n  color: #9ca3af;\n  font-style: italic;\n}\n\n.entity-edit-page .dividend-date-section .tax-year {\n  padding: 1px 5px;\n  background: #059669;\n  color: white;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 600;\n}\n\n.entity-edit-page .dividend-detail-btn {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1px solid #d1d5db;\n  background: #f9fafb;\n  color: #6b7280;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  margin-left: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.entity-edit-page .dividend-detail-btn:hover {\n  background: #059669;\n  color: white;\n  border-color: #059669;\n}\n\n/* Dividend detail modal */\n.dividend-detail-modal {\n  max-width: 450px;\n}\n\n.dividend-detail-modal .modal-body {\n  padding: 16px 20px;\n}\n\n.dividend-detail-grid {\n  margin-bottom: 16px;\n}\n\n.dividend-detail-grid .detail-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border-radius: 4px;\n}\n\n.dividend-detail-grid .detail-row:nth-child(odd) {\n  background: #f8fafc;\n}\n\n.dividend-detail-grid .detail-row.highlight {\n  background: #fef3c7;\n  font-weight: 600;\n}\n\n.dividend-detail-grid .detail-row.highlight-green {\n  background: #d1fae5;\n  font-weight: 600;\n}\n\n.dividend-detail-grid .detail-row.total {\n  border-top: 1px solid #e5e7eb;\n  font-weight: 600;\n  margin-top: 4px;\n  padding-top: 12px;\n}\n\n.dividend-detail-grid .detail-label {\n  color: #374151;\n}\n\n.dividend-detail-grid .detail-value {\n  font-weight: 600;\n  color: #111827;\n}\n\n.dividend-detail-grid .detail-value.neg {\n  color: #dc2626;\n}\n\n.dividend-detail-section {\n  margin-bottom: 16px;\n  padding: 12px;\n  background: #f8fafc;\n  border-radius: 6px;\n}\n\n.dividend-detail-section h5 {\n  margin: 0 0 8px 0;\n  color: #1f2937;\n  font-size: 13px;\n}\n\n.dividend-detail-section .section-hint {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 0 0 8px 0;\n}\n\n.dividend-detail-section .tax-year-info {\n  font-size: 12px;\n  color: #059669;\n  margin: 0;\n  font-weight: 500;\n}\n\n.dividend-detail-section.result {\n  background: #ecfdf5;\n  border: 1px solid #a7f3d0;\n}\n\n.dividend-detail-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 12px;\n  background: #fef3c7;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #92400e;\n}\n\n.dividend-detail-note .note-icon {\n  flex-shrink: 0;\n}\n\n/* Affectation Detail Modal - improved styling */\n.affectation-detail-modal {\n  min-width: 420px;\n}\n\n.affectation-detail-modal .modal-header h4 {\n  font-size: 15px;\n  color: #1F2937;\n}\n\n.affectation-detail-modal .modal-body {\n  padding: 16px 20px;\n}\n\n.affectation-section {\n  margin-bottom: 20px;\n  padding: 14px 16px;\n  background: linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%);\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n}\n\n.affectation-section h5 {\n  margin: 0 0 10px 0;\n  font-size: 13px;\n  color: #1E293B;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.affectation-section .section-hint {\n  font-size: 11px;\n  color: #64748B;\n  margin: 0 0 10px 0;\n  font-style: italic;\n}\n\n.affectation-detail-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.affectation-detail-grid .detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background: white;\n  border-radius: 6px;\n  font-size: 12px;\n}\n\n.affectation-detail-grid .detail-row.indent {\n  margin-left: 16px;\n  background: #FAFAFA;\n}\n\n.affectation-detail-grid .detail-row.sub-hint {\n  background: transparent;\n  padding: 2px 12px;\n}\n\n.affectation-detail-grid .detail-label-small {\n  font-size: 10px;\n  color: #9CA3AF;\n  font-style: italic;\n}\n\n.affectation-detail-grid .detail-row.total {\n  background: linear-gradient(90deg, #E0E7FF 0%, #EEF2FF 100%);\n  font-weight: 600;\n  border: 1px solid #C7D2FE;\n  margin-top: 4px;\n}\n\n.affectation-detail-grid .detail-row.highlight-green {\n  background: linear-gradient(90deg, #D1FAE5 0%, #ECFDF5 100%);\n  border: 1px solid #A7F3D0;\n  font-weight: 600;\n}\n\n.affectation-detail-grid .detail-label {\n  color: #374151;\n}\n\n.affectation-detail-grid .detail-value {\n  font-weight: 600;\n  color: #111827;\n}\n\n.affectation-detail-grid .detail-value.pos {\n  color: #059669;\n}\n\n.affectation-detail-grid .detail-value.neg {\n  color: #DC2626;\n}\n\n.affectation-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px 14px;\n  background: linear-gradient(90deg, #FEF3C7 0%, #FFFBEB 100%);\n  border: 1px solid #FDE68A;\n  border-radius: 8px;\n  font-size: 11px;\n  color: #92400E;\n  line-height: 1.5;\n}\n\n.affectation-note .note-icon {\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.entity-edit-page .treasury-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px 8px;\n  border-radius: 4px;\n  margin-bottom: 4px;\n}\n\n.entity-edit-page .treasury-row:hover {\n  background: rgba(217, 119, 6, 0.1);\n}\n\n.entity-edit-page .treasury-label {\n  font-size: 12px;\n  color: #78350F;\n  cursor: help;\n}\n\n.entity-edit-page .treasury-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: #78350F;\n}\n\n.entity-edit-page .treasury-value.neg {\n  color: #DC2626;\n}\n\n.entity-edit-page .treasury-row.net-row {\n  background: rgba(5, 150, 105, 0.1);\n  border: 1px solid rgba(5, 150, 105, 0.3);\n}\n\n.entity-edit-page .treasury-row.net-row .treasury-value {\n  color: #059669;\n}\n\n.entity-edit-page .treasury-breakdown {\n  display: flex;\n  gap: 16px;\n  font-size: 10px;\n  color: #92400E;\n  padding: 2px 8px;\n  margin-bottom: 6px;\n}\n\n.entity-edit-page .treasury-impact {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  background: #FFFBEB;\n  border: 1px solid #FCD34D;\n  border-radius: 4px;\n  margin-top: 8px;\n}\n\n.entity-edit-page .treasury-impact .impact-icon {\n  font-size: 14px;\n}\n\n.entity-edit-page .treasury-impact .impact-text {\n  font-size: 11px;\n  color: #78350F;\n  line-height: 1.3;\n}\n\n/* Fiscal params row */\n.entity-edit-page .hypotheses-edit-form .fiscal-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.entity-edit-page .hypotheses-edit-form .fiscal-row label {\n  font-size: 12px;\n  color: #64748B;\n}\n\n.entity-edit-page .hypotheses-edit-form .fiscal-row input[type=\"number\"] {\n  width: 50px;\n  padding: 5px 8px;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  font-size: 13px;\n  text-align: right;\n}\n\n.entity-edit-page .hypotheses-edit-form .fiscal-row input[type=\"number\"]:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.entity-edit-page .hypotheses-edit-form .fiscal-row .separator {\n  color: #CBD5E1;\n  font-size: 12px;\n}\n\n.entity-edit-page .hypotheses-edit-form .small-input {\n  width: 50px !important;\n}\n\n/* Dates row in hypothesis editor */\n.entity-edit-page .hypotheses-edit-form .dates-row {\n  flex-wrap: wrap;\n}\n\n.entity-edit-page .hypotheses-edit-form .dates-edit-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.entity-edit-page .hypotheses-edit-form .dates-edit-row label {\n  font-size: 12px;\n  color: #64748B;\n  font-weight: 500;\n}\n\n.entity-edit-page .hypotheses-edit-form .dates-edit-row .date-input {\n  padding: 6px 10px;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  font-size: 13px;\n  background: white;\n  cursor: pointer;\n}\n\n.entity-edit-page .hypotheses-edit-form .dates-edit-row .date-input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.entity-edit-page .hypotheses-edit-form .dates-edit-row .cloture-select {\n  padding: 6px 10px;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  font-size: 12px;\n  background: white;\n  cursor: pointer;\n  min-width: 120px;\n}\n\n.entity-edit-page .hypotheses-edit-form .dates-edit-row .cloture-select:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.entity-edit-page .hypotheses-edit-form .dates-edit-row .first-exercice-select {\n  padding: 6px 10px;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  font-size: 12px;\n  background: white;\n  cursor: pointer;\n  min-width: 80px;\n}\n\n.entity-edit-page .hypotheses-edit-form .dates-edit-row .first-exercice-select:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.entity-edit-page .hypotheses-edit-form .dates-edit-row .separator {\n  color: #CBD5E1;\n  font-size: 14px;\n}\n\n/* Date info in read-only summary */\n.entity-edit-page .step2-summary .dates-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.entity-edit-page .step2-summary .dates-info .date-sep {\n  color: #CBD5E1;\n  font-size: 11px;\n}\n\n/* Exercice limit warning */\n.entity-edit-page .exercice-limit-warning {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 14px;\n  background: #FEF3C7;\n  border: 1px solid #F59E0B;\n  border-radius: 6px;\n  margin-top: 12px;\n  font-size: 12px;\n  color: #92400E;\n  line-height: 1.4;\n}\n\n.entity-edit-page .exercice-limit-warning .warning-icon {\n  flex-shrink: 0;\n  font-size: 14px;\n}\n\n/* ===================== SARL DIVIDEND WARNING ===================== */\n/* Warning for SARL when dividends exceed 10% of capital (SSI charges) */\n\n.entity-edit-page .sarl-dividend-warning {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 14px;\n  background: #FEF3C7;\n  border: 1px solid #F59E0B;\n  border-radius: 6px;\n  margin: 8px 16px;\n  font-size: 12px;\n  color: #92400E;\n  line-height: 1.5;\n}\n\n.entity-edit-page .sarl-dividend-warning .warning-icon {\n  flex-shrink: 0;\n  font-size: 14px;\n}\n\n.entity-edit-page .sarl-dividend-warning .warning-text {\n  flex: 1;\n}\n\n/* ===================== SHOW RELATION BUTTON ===================== */\n\n.entity-edit-page .btn-show-relation {\n  background: #3B82F6;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  width: 24px;\n  height: 24px;\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.entity-edit-page .btn-show-relation:hover {\n  background: #2563EB;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
